isUserAuthenticated = isUserAuthenticated || false;
ssoFlag = ssoFlag || false;
isShareTemplate = isShareTemplate || false;
customeAcctName = '';
$.ezdia = $.ezdia || {};
$.ezdia.config = $.ezdia.config || {};
$.ezdia.config.pageParams = $.ezdia.config.pageParams || {};

$.ezdia.config.validate_key = {
    unique: {
        key: 'ez.validate.unique',
        index: 'ez.validate.unique.index'
    }
};

$.ezdia.config.VISUAL_STATUS_MAPPING = {
    "In Initial Processing": "In Initial Processing",
    "In Topic Creation": "In Topic Creation",
    "In Topic Approval": "In Topic Approval",
    "Topic Approved": "Topic Approved",
    "Topic Sent for Rework": "Topic Sent for Rework",
    "In Keyword Research": "In Keyword Research",
    "In Writing": "In Writing",
    "In Editing": "In Editing",
    "In QA": "In QA",
    "Delivered": "Delivered",
    "Approved": "Approved",
    "Sent for Rework": "Sent for Rework",
    "In Publishing": "In Publishing",
    "Published": "Published",
    "Reopened": "Reopened",
    "Reopen": "Reopened",
    "Reassigned": "Reassigned",
    "Returned": "Returned"
};
$.ezdia.config.STATUS_CSS_MAPPING = {
        //Project status classes
    "In Initial Processing": "label label-processing-standard",
    "Processing": "label label-processing-standard",
    "In Topic Creation": "label label-processing-standard",
    "In Topic Approval": "label label-progression-one-standard",
    "Topic Approved": "label label-actionsuccess-standard",
    "Topic Sent for Rework": "label label-softalert-standard",
    "In Research": "label label-progression-one-standard",
    "In Review": "label label-progression-one-standard",
    "In Translation": "label label-progression-one-standard",
    "In Keyword Research": "label label-progression-one-standard",
    "Keyword Research": "label label-progression-one-standard",
    "In Writing": "label label-progression-two-standard",
    "Writing": "label label-progression-two-standard",
    "In Editing": "label label-progression-three-standard",
    "In Verification": "label label-progression-three-standard",
    "In Audit": "label label-progression-four-standard",
    "Editing": "label label-progression-three-standard",
    "In QA": "label label-progression-four-standard",
    "In Keyword QA": "label label-progression-four-standard",
    // for link building solution
    "In QA Review": "label label-progression-four-standard",
    "In DBA Review": "label label-progression-four-standard",
    // end
    "QA": "label label-progression-four-standard",
    "Delivered": "label label-actionsuccess-standard",
    "Completed": "label label-actionsuccess-standard",
    "Approved": "label label-progression-three-standard",
    "Sent for Rework": "label label-softalert-standard",
    "In Publishing": "label label-progression-four-standard",
    "Published": "label label-progression-four-standard",
    "Returned": "label label-processing-standard",
    "Returned to Client": "label label-processing-standard",
    // Role status classes
    "New": "label label-processing-standard",
    "Assigned": "label label-actionsuccess-standard",
    "Re-Assigned": "label label-actionsuccess-standard",
    "Saved": "label label-softalert-standard",
    "Submitted": "label label-progression-three-standard",
    "Deliverable": "label label-progression-four-standard",
    "Reassigned": "label label-actionsuccess-standard",
    "Reopened": "label label-alert-standard",
    "Reopen": "label label-alert-standard",
    "In Progress": "label label-alert-standard"
};

$.ezdia.config.PROJECT_TYPE_CSS_MAPPING = {
    "Product Page": "label-light-blue",
    "Category Page": "label-light-green",
    "Buying Guide": "label-amber",
    "Onsite Blog": "label-indigo",
    "Offsite Blog": "label-deep-orange",
    "Article": "label-cyan",
    "Web Page": "label-pink"
};

$.ezdia.config.COLOR_PALETTE = [];

$.ezdia.config.ENTITY_COLOR_PALETTE = ["#FF6384","#A679AF","#FFCD56","#79C850","#6E90BA","#58CFFF",
    "#f79aae","#e1a5ec", "#f5d895", "#b4e49b", "#a0c6f5","#a7e3fb"];
       
$.ezdia.config.CONTENT_TEMPLATE_NAME = $.ezdia.config.CONTENT_TEMPLATE_NAME || {};

(function ($) {

    $.fn.basicSearchAccount = function (url) {
        var config = $.ezdia.config.pageParams;
        var account = config.account;
        var elem = $(this);

        if(config.tab == 'GlobalDashboard'){
            $('#ez-nav-my-dashboard').addClass('active');
        } else {
            var currElem = elem.find('[data-value="' + account + '"]').addClass('active');
            var value = currElem.text();

            $('#ez-dashboard-project-name').html(value);
        }

        elem.on('click', 'a', function(){
            var size = config.size;
            var params = "accountName=" + $(this).data('value');
            params += "&role=" + config.role;
            if (size) {
                params += "&size=" + size;
            }
            window.location.href = url + '?' + params;
        });

        return this;
    };

    $.fn.basicSearchRole = function (url) {
        var config = $.ezdia.config.pageParams;
        var $elem = $(this);

        $elem.val(config.role).change(function () {
            var size = config.size;
            var userManagement = config.userManagement;
            var isCreator = config.isCreator;
            var params = "accountName=" + config.account;
            params += "&role=" + $elem.val();
            if (size) {
                params += "&size=" + size;
            }
            if (userManagement) {
                params += "&userManagement=" + userManagement;
            }
            if (isCreator) {
                params += "&isCreator=" + isCreator;
            }
            window.location.href = url + '?' + params;

        });
        return this;
    };
})(jQuery);

(function ($) {
    var getId = function(optionalIdString) {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        optionalIdString = optionalIdString ? (optionalIdString + '__') : '';

        for (var i = 0; i < 5; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }

        return 'ez_js__' + optionalIdString + text;
    };

    $.extend(this, {
        makeId: function() {
            var idsArray = [];

            return function(optionalIdString) {
                var id = getId(optionalIdString);

                while (idsArray.indexOf(id) !== -1) {
                    id = getId();
                }

                idsArray.push(id);

                return id;
            };
        }(),
        sanitizer: {
            script: function (str) {
                var reg = '<[\\s||\/]*script';
                var patt = new RegExp(reg, 'ig');
                var script = patt.test(str);
                if (script) {
                    str = this.html(str);
                }
                return str;
            },
            html: function (str) {
                if(str) {
                    str = str.replace(/&/g, "&amp;")
                        .replace(/</g, "&lt;")
                        .replace(/>/g, "&gt;")
                        .replace(/"/g, "&quot;")
                        .replace(/'/g, "&#039;");
                    var unicodeChar = '\u2019';
                    str.replace(new RegExp(unicodeChar, "g"), "&rsquo;");
                }

                return str;
            },
            specialChar: function (str) {
                return str ? str.replace(/[^\w]/gi, '') : str;
            },
            quotes: function (str) {
                return str ? str.replace(/"/g, "&quot;").replace(/'/g, "&#039;") : str;
            }
        },
        template: {
            get: function (key, partial, db, type) {
                var templates = $.data(document, 'ez.templates') || $.data(document, 'ez.templates', {});

                if (db) {
                    if (!templates[key]) {
                        templates[key] = this._compileDb(key, type);
                    }
                } else {
                    var id = '#ez-template-' + key;
                    if (!templates[key]) {
                        templates[key] = this._compile(id, partial);
                    }
                }

                return templates[key];
            },
            _compileDb: function (id, type) {
                var template = $.ezdia.templateDb.get(id, type);

                if (!$.isEmptyObject(template) && template[0]) {
                    return Handlebars.compile(template[0].content);
                } else {
                    return null;
                }
            },
            _compile: function (id, partial) {
                var source = $(id).html();
                var compile;

                try {
                    compile = Handlebars.compile(source);
                } catch (e) {
                    console.error('Error in compling template ', id, ' is missing.');
                    compile = Handlebars.compile('<div></div>');
                }

                if (partial) {
                    $.each(partial, function (name, id) {
                        Handlebars.registerPartial(name, $('#ez-template-' + id).html());
                    });
                }

                return compile;
            }
        },
        getContentTemplate: function () {
            var templates = $('script[id^="ez-tinymce-email-template-"]');

            $.each(templates, function () {
                var elem = $(this);
                var name = elem.data('name');
                var content = elem.html();

                $.ezdia.config.CONTENT_TEMPLATE_NAME[name] = content;
            });
        },
        getEditorTemplate: function(nameArray, type){
            var templates = $.data(document, 'ez.editor.templates') || $.data(document, 'ez.editor.templates', {});
            var returnArray = [];
            var reqArray = [];
            var reqArrayIndex = [];
            var respArray = [];
            var in_local = false;

            if (nameArray && !type) {
                $.each(nameArray, function(i, name){
                    if (!templates[name]) {
                        reqArray.push(name);
                        reqArrayIndex.push(i);
                    } else {
                        returnArray[i] = templates[name];
                        in_local = true;
                    }
                });
            } if (templates[type]) {
                returnArray = templates[type];
            }

            if (reqArray.length || type) {
                respArray = $.ezdia.templateDb.get(reqArray, type);

                if (respArray) {
                    if (type) {
                        templates[type.toString()] = respArray;
                        returnArray = respArray;
                    } else {
                        if (!in_local) {
                            returnArray = returnArray.concat(respArray);
                        }

                        $.each((respArray || []), function(i, obj){
                            var index = -1;

                            if (obj) {
                                templates[obj.name] = obj;

                                if (in_local) {
                                    index = reqArrayIndex[i];
                                    returnArray[index] = obj;
                                }
                            }
                        });
                    }
                }
            }

            return returnArray.length ? returnArray : null;
        },
        templateDb: {
            get: function (name, type) {
                var arr = [];
                var data = 'key=' + name.toString();
                    data += '&type=' + (type ? type.toString() : '');

                $.ajax({
                    type: "GET",
                    url: 'fetchTemplates.htm',
                    data: data,
                    dataType: 'json',
                    async: false,
                    success: function (response) {
                        if(!response.length){
                            arr = null;
                        } else {
                            arr = response;
                        }
                    },
                    error: function (error) {
                        arr = null;
                    }
                });

                return arr;
            }
        },
        getJsonObject: function (json) {
            var obj = {};

            if (json) {
                try {
                    if (typeof json !== 'object') {
                        obj = JSON.parse(json);
                    } else {
                        obj = json;
                    }
                }
                catch (err) {
                    obj = '';
                    //console.log(err);
                }
            } else {
                obj = '';
            }

            return obj;
        },
        validateForm: {
            errorPlacement: function (error, element) {
                if (element.parent('.input-group').length || element.prop('type') === 'checkbox' || element.prop('type') === 'radio') {
                    error.insertAfter(element.parent());
                } else {
                    error.insertAfter(element);
                }
            },
            highlight: function (element) {
                var id_attr = "#" + $(element).attr("id") + "-feedback";
                $(element).closest('.form-group').removeClass('has-success').addClass('has-error');
                $(id_attr).removeClass('glyphicon-ok').addClass('glyphicon-remove');
            },
            unhighlight: function (element) {
                var id_attr = "#" + $(element).attr("id") + "-feedback";
                $(element).closest('.form-group').removeClass('has-error').addClass('has-success');
                $(id_attr).removeClass('glyphicon-remove').addClass('glyphicon-ok');
            }
        },
        isLocalStorage: function(){
            return (typeof(Storage) !== 'undefined') ? true : false;
        },
        isLocalStorageEnable: function(){
            var returnVal = false;

            if (typeof(Storage) !== 'undefined') {
                try {
                    localStorage.setItem("test", "test");
                    localStorage.removeItem("test");
                    returnVal = true;
                } catch(e) {
                    returnVal = false;
                }
            }

            return returnVal;
        }(),
        scrollTo : function(id){
            var scrollTop = 0;
            var animated_wrapper = $('.animated-wrapper');
            var topPad = 0;

            if (animated_wrapper.length) {
                topPad = animated_wrapper.css('paddingTop') || 0;
                topPad = parseInt(topPad);
            }
            if (id instanceof jQuery) {
                scrollTop = id.offset().top;
            } else {
                scrollTop = $('#' + id).offset().top;
            }
            $('html, body').animate({
                scrollTop: scrollTop - topPad
            }, 500);
        },
        leftNavToogle: function(){
            $('#ez-page-nav-left-show').on('click', function(){
                var top = $('#ez-page-top-navbar').outerHeight();

                $('#ez-page-nav-left').addClass('slideOpen').removeClass('slideClose').css({
                    top: top
                });
                $('#ez-nav-left-wrapper').addClass('display').css({
                    top: top
                });
            });
            $('#ez-page-nav-left-hide, #ez-nav-left-wrapper').on('click', function(){
                $('#ez-page-nav-left').addClass('slideClose').removeClass('slideOpen');
                $('#ez-nav-left-wrapper').removeClass('display');
            });
        },
        ValidUrl: function(str) {
             // protocol
            var pattern = new RegExp('^(\\/\\/)?'+
             // domain name
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+
             // OR ip (v4) address
            '((\\d{1,3}\\.){3}\\d{1,3}))'+
            // port and path
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+
            // query string
            '(\\?[;&a-z\\d%_.~+=-]*)?'+
            // fragment locator
            '(\\#[-a-z\\d_]*)?$','i');

            return (!pattern.test(str)) ? false : true;
        },
        checkurl: function (param) {
            var query = window.location.search.substring(1);
                query = query.split('&');
            var count = $.inArray(param, query);

            if (count !== -1) {
                return query[count];
            } else {
                return false;
            }

        },
        successMsg: function(msg, error){
            var template = $.ezdia.template.get('success-message-alert');
            var context = {
                message: msg,
                classes: error ? 'danger' : 'success'
            };
            var id = $('#ez-success-message-alert');

            if (id.length) {
                id.remove();
            }

            $('body').append(template(context));

            setTimeout(function() {
                $('#ez-success-message-alert').remove();
            }, 30000);
        },
        getAccountName: function(value){
            var pageParams = $.ezdia.config.pageParams || {};
            var account = value;
            if (pageParams.allProjects) {
                var projects = ezdia.util.jsonParse(pageParams.allProjects);
                $.each(projects, function (key, accounts) {
                    $.each(accounts, function (accName, accLabel) {
                        if(accName === account) {
                            account = accLabel;
                            return false;
                        }
                    });
                });
            }

            return account;
        },
        getRoleName: function (value){
            var pageParams = $.ezdia.config.pageParams || {};
            var allRoles = pageParams.allRoles;
            var role = value;

            if (allRoles) {
              if ( typeof allRoles === 'string') {
                allRoles = allRoles.split(',');

                $.each(allRoles, function(i, str){
                    var arr = str.split('=');
                    var roleVal = arr[0] ? arr[0].trim() : '';
                    if (value == roleVal) {
                        role = arr[1];
                        return false;
                    }
                });
              } else {
                role = allRoles[value]
              }
            }

            return role;

        },
        digits: function(number){

            if (!number) {
                number = 0;
            }

            if (typeof number === 'string') {
                number = parseInt(number);
            }
            //Seperates the components of the number
            var num = number.toString().split(".");
            //Comma-fies the first part
            num[0] = num[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            //Combines the two sections
            return num.join(".");
        },
        defaultColumnLayout: function (column){
            var config = column.config || {};
            var singleClo = ['comment', 'creativebrief', 'filetype', 'groupField', 'html', 'inline', 'inputlist', 'inputtab', 'json', 'multichoice', 'textarea', 'warning', 'attributes', 'url', 'segment'];
            var columnLayout = '';

            if (config.column_layout) {
                columnLayout = config.column_layout;
            } else if ($.inArray(column.edittype, singleClo) === -1 && !config.entity) {
               columnLayout = 'column-layout-two';
            } else {
                columnLayout = '';
            }

            return columnLayout;
        },
        stickyFormBtns: function(obj){
            var classes = obj.cls || 'fixed';
            var sticky = $('#' + obj.sticky);
            var frm = $('#' + obj.frm);

            if (!sticky.length || !frm.length) {
                return;
            }

            frm.data('scrolling', false);
            sticky.removeClass(classes);

            $( window ).off('.ez.sticky.form.btn').on('scroll.ez.sticky.form.btn', function() {
                var active = frm.data('scrolling');

                if (!active) {
                    frm.data('scrolling', true);
                    setTimeout(function(){
                        var docViewTop = $(window).scrollTop();
                        var docViewBottom = docViewTop + $(window).height();
                        var elemTop = frm.offset().top + 100;

                        if (elemTop <= docViewBottom) {
                            sticky.addClass(classes);
                        } else {
                            sticky.removeClass(classes);
                        }
                        frm.data('scrolling', false);
                    }, 100);
                }

            });
        },
        getWrapper: function(id) {
            var wrap = $('#' + id);

            if (!wrap.length) {
                var wrapper = $('<div>', {
                    id: id
                });

                $('body').append(wrapper);

                wrap = $('#' + id);
            }

            return wrap;
        },
        initGenericSearch: function(frm, exportFn, searchUrl){
            var pageParams = $.ezdia.config.pageParams || {};
            var searchObj = {
                advance: {
                    queryfields: pageParams.searchFieldsJson
                },
                callbacks: {
                    search: $.ezdia.genericSearchAjax
                },
                searchUrl: searchUrl
            };

            if (exportFn) {
                searchObj.callbacks.export = exportFn;
            }

            if (pageParams.basicSearchFields.length > 0) {
                searchObj = $.extend(true, {}, searchObj, {
                    enablebasic: true,
                    basic: {
                        queryfields: pageParams.basicSearchFields
                    }
                });
            }

            if (pageParams.requestParam) {
                searchObj.requestParam = pageParams.requestParam;
            }

            $(frm).search(searchObj);
        },
        genericSearchAjax: function(query,searchQueryName,searchUrl){
            var pageParams = $.ezdia.config.pageParams;

            $("#grid").jqGrid("setGridParam", {
                datatype: "json",
                mtype: 'POST',
                url: searchUrl || 'searchData.htm',
                page: 1,
                jsonReader: {
                    records: 'records',
                    root: (searchUrl === "ezaListsData.htm" || searchUrl === "ezaAlertsData.htm" || searchUrl === "ezaAlertRulesData.htm") ? 'rows' : 'data',
                    total: 'total',
                    page: 'page'
                },
                postData: {
                    formtype: $("#pageTemplateName").val(),
                    accountName: pageParams.account || $('#accountName').val(),
                    searchString: query
                }
            }).trigger("reloadGrid" ,[{page:1}]);
            hideShowDeskForm();
        },
        showSuccessError: function (alertObj) {
            /* alertObj.message, alertObj.error: true? false, alertObj.autohide: true? false, alertObj.duration: 5000*/
            var $body = $('body');
            var template = $.ezdia.template.get('alert-welcome-task-plan-success-error');
            var content = template(alertObj);
            var autohide = alertObj.autohide === undefined ? true : alertObj.autohide;
            var alert = $body.find("#ezdia-floating-alert");

            if (alert.length) {
                $.ezdia.hideSuccessError(alert, 0);
            }

            alert = $body.append(content).find("#ezdia-floating-alert");

            setTimeout(function(){
                alert.css({
                    "right": 30
                }).find(".remove").on("click", function(){
                    $.ezdia.hideSuccessError(alert);
                });
            }, 0);

            if (autohide) {
                setTimeout(function(){
                    $.ezdia.hideSuccessError(alert);
                }, alertObj.duration || 5000);
            }

            return alert;
        },
        hideSuccessError: function(alert, duration) {
            duration = (duration === 0 || duration) ? duration : 500;

            alert.animate({
                opacity: 0
            }, duration, "linear", function() {
                alert.remove();
            });
        },
        getSelectedGridItemsIds: function (gridId) {
            var id = gridId || 'grid';
            var ids = $("#" + id).jqGrid('getGridParam', 'selarrrow') || [];
            if (ids.length === 0) {
                ids = $("#" + id).jqGrid('getGridParam', 'selrow');
                if (ids !== null) {
                    ids = [ids];
                } else {
                    ids = [];
                }
            }
            return $.unique(ids);
        },
        getSelectedGridItemsLength: function (gridId) {
            var grid = $('#' + (gridId || 'grid'));
            var selectAll = $('#selectAll').is(':checked');
            var selIds = [];
            var itemLen = 0;

            if (selectAll) {
                itemLen = grid.jqGrid('getGridParam', 'records');
            } else {
                selIds = getGridSelRow();
                itemLen = selIds.length;
            }

            return itemLen;
        }
    });
}).apply($.ezdia, [jQuery, document, window]);

(function ($, document) {
    var pageParams = {};

    var toggle = function(e){
        var elem = $(e.currentTarget);
        var classes = 'collapse-all';
        var grpCount = $.data(document, 'ez.formFieldsGroupsCount') || {};

        if (elem.hasClass(classes)) {
            expand();
            grpCount.open = grpCount.total;
        } else {
            collapse();
            grpCount.open = 0;
        }
        elem.toggleClass(classes);
    };

    var collapse = function () {
        var groups = $.data(document, 'ez.formFieldsGroups');
        $.each(groups, function (key, id) {
            if (id) {
                id.collapse('hide').siblings('#ez-grp-heading-' + key).addClass('collapsed');
            }
        });

    };

    var expand = function () {
        var groups = $.data(document, 'ez.formFieldsGroups');
        $.each(groups, function (key, id) {
            if (id) {
                id.collapse('show').siblings('#ez-grp-heading-' + key).removeClass('collapsed');
            }
        });

    };

    var createGrpName = function (grpObject) {
        var groups = $.data(document, 'ez.formFieldsGroups', {});
        var hasDefault = true;
        var arr = [];

        $.each(grpObject, function (i, obj) {
            var name = obj.name.toLowerCase();

            if (name == 'default') {
                hasDefault = false;
            }

            obj.name = $.ezdia.sanitizer.specialChar(name);

            if ( $.inArray( obj.name, arr ) > -1 ) {
                obj.duplicate = true;
            } else {
                arr.push(obj.name);
            }

            groups[obj.name] = '';
            $('#ez-grp-body-' + obj.name).remove();
        });

        if (hasDefault) {
            grpObject.push({
                label: 'Default',
                name: 'default'
            });
            groups['default'] = '';
        }

        $('#ez-grp-toggle-all').removeClass('collapse-all');
        $('body').off('.ez.expandCollapseGrpAll').on('click.ez.expandCollapseGrpAll', '#ez-grp-toggle-all', toggle);
        return groups;
    };

    var watchToggle = function() {
        var collapsed = !$(this).hasClass("collapsed");
        var grpCount = $.data(document, 'ez.formFieldsGroupsCount');

        if (collapsed) {
            grpCount.open--;
            if (!grpCount.open) {
                $('#ez-grp-toggle-all').addClass('collapse-all');
            }
        } else {
            grpCount.open++;
            if (grpCount.open == grpCount.total) {
                $('#ez-grp-toggle-all').removeClass('collapse-all');
            }
        }
    };

    var clearfloat = function(name, group, layoutObj) {
        var countObj = $.data(document, 'ez.formGroupsCount') || $.data(document, 'ez.formGroupsCount', {});

        if (!layoutObj.editable) {
            countObj[name] = null;
        } else if (countObj[name] == 'column-layout-two' && layoutObj.layout == 'column-layout-two'){
            group.append($('<div>', {
                style: 'clear: both'
            }));
            countObj[name] = null;
        } else {
            countObj[name] = layoutObj.layout;
        }
    };
    $.extend(this, {
        groupFormField: {
            jspGroup: function(container){
                var config = $.ezdia.config.pageParams;
                var self = this;
                var arr = config.groups;
                var column = config.colModel || config.column;
                var group = [];

                arr = arr.filter(function(itm, i, arr){
                    return i==arr.indexOf(itm);
                });

                if (arr.length >= 1) {
                    $.each(arr, function(i, mval){
                        group.push({
                            name: $.ezdia.sanitizer.specialChar(mval),
                            label: mval
                        });
                    });

                    $(container).html(this.create(group));

                    $.each(column, function(i, obj){
                        var elem = $('#' + obj.name);
                        var id = $('#' + obj.name + '-main');
                        var type = elem.data('type');

                        if(id.length){
                            var col_layout = $.ezdia.defaultColumnLayout(obj);
                            var content = id.detach();

                            if (type == 'inputtab'){
                                $(container).append(content);
                            } else {
                                content.addClass(col_layout);
                                self.append($.ezdia.sanitizer.specialChar(obj.groupName), content);
                            }
                        }
                    });
                    this.hide();
                    $('#ez-form-group-collapse-link-wrapper').show();
                } else {
                    $('#preloaded-contant').show();
                }
            },
            create: function (grpObject) {
                var template = $.ezdia.template.get('form-group-wrapper');
                pageParams = $.ezdia.config.pageParams || {};

                createGrpName(grpObject);

                return template(grpObject);
            },
            tabs: function(grpObject){
                var template = $.ezdia.template.get('form-group-navs');

                return template(grpObject);

            },
            chartTabs: function(grpObject){
                var template = $.ezdia.template.get('chart-navs');

                return template(grpObject);

            },
            append: function (grpName, data, layoutObj) {
                layoutObj = layoutObj || {};
                if (!data) {
                    return false;
                }
                var groups = $.data(document, 'ez.formFieldsGroups');
                var name;

                grpName = $.ezdia.sanitizer.specialChar(grpName || 'default');
                grpName = grpName.toLowerCase();

                if (grpName && !groups[grpName]) {
                    var id = '#ez-grp-body-' + grpName;
                    groups[grpName] = $(id);
                }

                if (grpName && groups[grpName].length) {
                    name = groups[grpName];
                } else {
                    if (!groups['default']) {
                        groups['default'] = $('#ez-grp-body-default');
                    }
                    name = groups['default'];
                }

                name.append(data);

                if (layoutObj.type && layoutObj.type != 'hidden') {
                    clearfloat(grpName, name, layoutObj);
                }

            },
            hide: function (formtype) {
                var groups = $.data(document, 'ez.formFieldsGroups');
                var grpCount = $.data(document, 'ez.formFieldsGroupsCount', {});
                var count = 0;
                var tabs = null;

                $.each(groups, function (key) {
                    var row = $('#ez-grp-body-' + key).find('[data-row="row"]:visible');
                    if (!row.length) {
                        tabs = $('a[href="#ez-grp-'+ key +'"]');
                        $('#ez-grp-body-' + key).closest('[data-group="form fields"]').remove();

                        if (tabs.length) {
                            tabs.parent('li').remove();
                        }

                        delete groups[key];
                    } else {
                        count++;
                        $('#ez-grp-heading-' + key).on('click.ez.expandCollapseGrp', function(){
                            watchToggle.call(this);
                        });
                    }
                });

                grpCount["total"] = count;
                grpCount["open"] = count;

//                if ((formtype === 'edit' || formtype === 'update_item') && pageParams.module === 'desk' && !pageParams.userManagement && pageParams.role === 'pm'){
//                    $('#ez-grp-toggle-all').trigger('click');
//                }
            },
            clear: function () {
                $.data(document, 'ez.formFieldsGroups', {});
                $.data(document, 'ez.formGroupsCount', {});
                $('body').off('.ez.expandCollapseGrpAll').off('.ez.expandCollapseGrp');
            }
        }
    });
}).apply($.ezdia, [jQuery, document]);

(function ($, document) {

    $.validator.setDefaults({
        ignore: []
    });

    var getBtnPos = function(btn){
        var pos = btn.offset();
        var width = btn.outerWidth();

        return {
            left: pos.left + width/2 + 'px',
            top: pos.top + 'px'
        };
    };

    var getRules = function(column){
        var rules = null;

        if (column.edittype === 'int') {
            rules = {
                number: true
            };
        } else if (column.edittype === 'email') {
            rules = {
                required: true,
                email: true
            };
        } else {
            rules = {
                required: column.required
            };
        }

        return rules;
    };

    var getObject = function(obj, frm){

        var validObj = {
            errorClass: "validation-error-msg",
             showErrors: function(){
                 toggleError.call(this);
             },
             onkeyup: false,
             ezcontainer: frm.find('.ez-error-msg-lst'),
             ezerrorElement: $.ezdia.template.get('error-item')
        };

        return $.extend({}, obj, validObj);
    };

    var toggleError = function(){
        if (!$.isEmptyObject(this.errorList)) {
            highlight.call(this);
        } else if (this.settings.unhighlight) {
            unhighlight.call(this);
        }
    };

    var highlight = function(){
        var self = this;
        var obj = this.errorList;
        var container = this.settings.ezcontainer;
        var count = 0;

        $.each(obj, function(i, mobj){
            var elem = $(mobj.element);
            var id = ( elem.attr('id') || elem.attr('name') ) + '-error';
            var err = $('#'+ id);
            var row = null;

            if (err.length) {
                row = elem.data('ezrow');
                err.show().find('[data-msg="msg"]').html(mobj.message);
                if(row) {
                    row.find('[data-validate="message"]').html(mobj.message).show();
                }
                
            } else {
                err = getErrorElem.call(self, id, mobj);
                container.append(err.list);
                row = elem.data('ezrow');
                row.append(err.input);
                $('#'+ id).on('click', function(){
                    $.ezdia.scrollTo(row);
                });
            }

            elem.data('ezrow').addClass('has-error');
            count++;
        });

        container.data('count', count).closest('[data-container="error"]').show();

        if (this.settings.isScroll && window.event.type === 'click' && window.event.target.type !== "select-one") {
            $('html,body').animate({
                scrollTop: container.offset().top},
            'slow');
        }
    };

    var unhighlight = function(element){
        var obj = element || this.validElements();
        var id = obj.data('errorId');
        var container = this.settings.ezcontainer;
        var count = container.data('count');

        if (!id) {
            return false;
        }

        $('#' + id).hide();
        obj.data('ezrow').removeClass('has-error').find('[data-validate="message"]').hide();

        count--;
        container.data('count', count);

        if (!count) {
            container.closest('[data-container="error"]').hide();
        }
    };

    var getErrorElem = function(id, obj){
        var elem = $(obj.element);
        var name = elem.attr('name');
        var label = $('[for="'+ name +'"]').text() || '';
        var rowInput = elem.closest('[data-row="input"]');
        var row = elem.closest('[data-row="row"]');
        var template = this.settings.ezerrorElement;

        if(elem.data("for")){
           label = elem.data("for");
        }
        
        if (!label) {
            label = row.find('.control-label').text() || '';
        }

        label = label.replace(/\*/ig, '');

        elem.data('errorId', id).data('ezrow', rowInput);

        var list = template({
            id: id,
            label: label,
            msg: obj.message,
            cls: 'text-danger'
        });

        var p = $('<p>', {
            html: obj.message,
            class: 'text-danger',
            'data-validate': 'message'
        });

        return  {
            list: list,
            input: p
        };
    };

    var createErrContainer = function(frm){
        var template = $.ezdia.template.get('error');
        var errContainer = frm.find('[data-container="error"]');
        var isScroll = true;

        if (!errContainer.length) {
            isScroll = false;
            frm.append('<div class="ez-error-container-placeholder" data-container="error" style="display: none"></div>');
            errContainer = frm.find('[data-container="error"]');
        }

        errContainer.html(template());
        return isScroll;
    };

    $.extend(this, {
        validate: {
            all: function(colModel, frmName) {
                var vObj = {};

                $.each(colModel, function(i, column){
                    var config = column.config || {};

                    if (column.edittype === 'hidden') {
                        return true;
                    }

                    if (column.required || config.validate_rules) {
                        $.ezdia.validate.init(vObj, column);
                    }
                });

                $.ezdia.validate.create(vObj, frmName);
            },
            init: function (validObj, column) {
                var config = column.config || {};
                validObj.rules = validObj.rules || {};
                validObj.messages = validObj.messages || {};

                if (config.validate_rules) {
                    if (column.required && config.validate_rules.required === undefined) {
                        config.validate_rules.required = true;
                    }
                    var req = config.validate_rules.required;

                    if (typeof req === 'string') {
                        config.validate_rules.required = $.ezdia.widgets.validates[req] || false;
                    }
                    validObj.rules[column.name] = config.validate_rules;
                } else {
                    validObj.rules[column.name] = getRules(column);
                }

                if (config.validate_messages) {
                    validObj.messages[column.name] = config.validate_messages;
                }

            },
            create: function (validObj, form, hasTab) {
                var frm = (form instanceof jQuery) ? form : $('#' +form);
                var obj = {};

//                if ($.isEmptyObject(validObj.rules) && !hasTab) {
//                    return false;
//                }

                var isScroll = createErrContainer(frm);

                obj = getObject(validObj || {rules: {pm: "required"}}, frm);
                obj.isScroll = isScroll;

                this.destroy(frm);
                frm.validate(obj);
            },
            destroy: function (form){
                var frm = (form instanceof jQuery) ? form : $('#' +form);
                var validObj = frm.data('validator');

                if (!validObj) {
                    return false;
                } else if (validObj.errorList.length) {

                    $.each(validObj.errorList, function(i, obj){
                        var ezrow = $(obj.element).data('ezrow');
                        if (ezrow) {
                            ezrow.removeClass('has-error').find('[data-validate="message"]').remove();
                        }

                    });

                    validObj.settings.ezcontainer.empty().closest('[data-container="error"]').hide();

                }
                $.removeData(frm.get(0),'validator');
            },
            highlightServerErrors: function(form, errList){
                var _this = this;
                var frm = (form instanceof jQuery) ? form : $('#' +form);
                var validObj = frm.data('validator');
                var validObject = {};
                var frmName = null;

                if (!validObj || $.isEmptyObject(validObj.settings.rules)) {
                    frmName = frm.attr('id');
                    $.each(errList, function(i, obj) {
                        _this.init(validObject, {
                            name: obj.name,
                            config:  {
                                validate_rules: obj.validate_rules
                            }
                        });
                    });
                    this.create(validObject, frmName);
                } else {
                    var rules = validObj.settings.rules;
                    $.each(errList, function(i, obj) {
                        if (!rules[obj.name]) {
                            frm.find( "[name="+ obj.name +"]" ).rules( "add", obj.validate_rules);
                        }
                    });
                }

                frm.valid();
            },
            unhighlight: function(form, element){
                var frm = (form instanceof jQuery) ? form : $('#' +form);
                var data = $.data(frm.get(0),'validator');
                unhighlight.call(data, element);
            }
        }
    });
}).apply($.ezdia, [jQuery, document]);

// Create Charts

(function ($) {
    var palette = '';
    var dataField = null;
    var colModel = null;
    var isChartEmpty = true;
    
    function formatQueryAndOpenUrl(e) {
        var url = e.point.url;
        
        if(!url){
            return;
        }        
        e.preventDefault();
        
        if (!this.search) {
            window.open(
                url,
                '_self'
            );
            return;
        }
        
        var searchParamsStr = url.split('?')[1];
        var searchData = $('#' + this.search.id).serializeArray();
                
        if (searchParamsStr) {
            var searchParams = new URLSearchParams(searchParamsStr);
            var filterKey = searchParams.get('filter');
        }
        
        if (filterKey) {
            var filterQStr = this.config.filter[filterKey];
            var filterQuery = ezdia.util.jsonParse(filterQStr);
            var fieldsNameMap = this.search.fieldsNameMap;
            var isArray = Array.isArray(filterQuery);
            var queryArray = [];
            var newFilterQuery;
            
            $.each(searchData, function(i, obj){
                if (obj.value) {
                    var name = fieldsNameMap[obj.name];
                    var query = {
                        name: name,
                        operator: 'EQ',
                        value: obj.value,
                        lower: '',
                        upper: ''
                    };
            
                    if(isArray) {
                        queryArray.push(query);
                    } else {
                        queryArray.push({
                            "field": query
                        });
                    }
                    
                }
            });
            
            if(isArray) {
                newFilterQuery = queryArray.concat(filterQuery);
            } else {
                var newrules = queryArray.concat(filterQuery.rules);
                newFilterQuery = {
                    "search_operand": "and",
                    "rules": newrules
                };
            }
            
            localStorage.setItem(filterKey, JSON.stringify(newFilterQuery));
        }
        
        window.open(
            url,
            '_self'
        );
    }

    var hasCustomColor = function (value) {
        var c;
        $.each(palette, function (i, obj) {
            if (obj.legend == value) {
                c = obj.color;
                return false;
            }
        });
        return c;
    };

    var setChartColor = function(arr){
        var obj = {};

        obj['name'] = arr[0];
        obj['y'] = Number(arr[1]);
        var color = hasCustomColor(obj['name']);

        if(color){
            obj['color'] = color;
        }

        return obj;
    };

    var pieData = function(data, chartObj){
        palette = (chartObj.config && chartObj.config.chart_color) || getCustomConfig('chart_color') || $.ezdia.config.COLOR_PALETTE;
        var arr = [];

        $.each(data, function(i, mval){
            if(mval.url){
                chartObj.cursor = true;
            }
            return false;
        });

        if(data && data.length && data[0].name) {

            if(palette){
                $.each(data, function(i, obj){
                   var color = hasCustomColor(obj['name']);

                    if(color){
                        obj['color'] = color;
                    }
                });
            }

            return data;
        }

        $.each(data, function(i, mval){
            var d = [];

            $.each(dataField, function(j, v){
                var label = dataField[j];
                var name = null;

                $.each(colModel, function(i, col){
                    if (label == col.label){
                        name = col.name;
                        return false;
                    }
                });
                if (name) {
                    d.push(data[i][name]);
                }
            });

            if(palette){
                d = setChartColor(d);
            }

            arr.push(d);
        });

        return arr.length ? arr : null;
    };

    var seriesData = function(dataObj, chartObj){
        var data = dataObj.series && !$.isEmptyObject(dataObj.series) ? dataObj.series : null;
        var config = chartObj.config || {};
        var arr = [];
        palette = (chartObj.config && chartObj.config.chart_color) || getCustomConfig('chart_color') || $.ezdia.config.COLOR_PALETTE;

        if(dataObj.yAxis && dataObj.yAxis.length) {

            $.each(dataObj.yAxis, function(i, mval){
                $.each(mval.data, function(i, mval2){
                    if(mval2.url){
                        chartObj.cursor = true;
                    }
                    return false;
                });
            });

            if(palette){
                $.each((dataObj.yAxis || {}), function(i, obj){
                   var color = hasCustomColor(obj['name']);

                    if(color){
                        obj['color'] = color;
                    }
                });
            }

            if (chartObj.type !== 'linechart' && !config.negative) {
                $.each(dataObj.yAxis, function(i, mval){
                    $.each(mval.data, function(i, mval2){
                        if(mval2.y < 0){
                            config.negative = true;
                        }
                        return false;
                    });
                    if (config.negative) {
                        return false;
                    }
                });
            }

            return dataObj.yAxis;
        } else if(!data){
            return null;
        }

        for (var key in data) {
            var obj = {
                name: key,
                data: data[key]
            };

            if(palette){
                var color = hasCustomColor(obj['name']);

                 if(color){
                     obj['color'] = color;
                 }
            }

            if (chartObj.type == 'barchart') {
                obj.events = {
                    legendItemClick: function () {
                        return false;
                    }
                };
            }
            arr.push(obj);
        }

        return arr;
    };

    var geoData = function(data){
        var arr = [];

        arr.push(dataField);
        for (var i = 0; i < data.length; i++) {
            var d = [];
            var brkFlag = true;
            for (var j = 0; j < dataField.length; j++) {
                if (data[i][dataField[j]] === "" || data[i][dataField[j]] === 0) {
                    brkFlag = false;
                    break;
                }
                d.push(data[i][dataField[j]]);
            }
            if (brkFlag) {
                arr.push(d);
            }
        }
        return arr;
    };

    function timeseriesData(dataObj, chartObj) {
        var config = chartObj.config;
        palette = config.chart_color || getCustomConfig('chart_color') || $.ezdia.config.COLOR_PALETTE;

        if (dataObj.yAxis && dataObj.yAxis.length) {
            $.each(dataObj.yAxis, function(i, mval){
                mval.type = 'area';
                var color = hasCustomColor(mval['name']);

                 if(color){
                     mval['color'] = color;
                 }
            });
            return dataObj.yAxis;
        } else {
            return null;
        }
    }

    var formatData = function(dataObj, obj){
        var type = null;
        var series = null;
        var arr = dataObj.response ? $.ezdia.getJsonObject(dataObj.response) : null;
        var xAxis = dataObj.xAxis ? dataObj.xAxis : null;
        var yAxis = dataObj.yAxis ? dataObj.yAxis : null;
        var title = dataObj.title;

        dataField = dataObj.colNames ? $.ezdia.getJsonObject(dataObj.colNames) : null;
        colModel = dataObj.colNames ? $.ezdia.getJsonObject(dataObj.colModel) : null;
        
        switch (obj.type) {
            case 'chart':
            case 'groupchart':
                arr = arr ? pieData(arr, obj) : null;
                break;
            case 'linechart':
            case 'barchart':
            case 'stackedchart':
            case 'columnchart':
                type = 'series';
                series = seriesData(dataObj, obj);
                break;
            case 'geochart':
                arr = arr ? geoData(arr) : null;
                break;
            case 'donutchart':
                arr = (dataObj.series && dataObj.series.inner) ? dataObj.series.inner : null;
                series = dataObj.series ? dataObj.series : null;
                break;
            case 'timeserieschart':
                series = timeseriesData(dataObj, obj);
                break;
            case 'chartsummary':
                arr;
            default:
                break
        }

        if ((arr && typeof(arr) === "object") || (arr && arr.length) || (series && series.length)) {
            return {
                xAxis: xAxis,
                yAxis: yAxis,
                title: title,
                series: series,
                arr: arr
            };
        } else if (!obj.started) {
            var data = dataObj.sample ? $.ezdia.getJsonObject(dataObj.sample) : '';

            if (!data){
                return null;
            }

            if (type == 'series') {
                series = data;
            } else {
                arr = data;
            }

            obj.sample = true;
            return {
                xAxis: xAxis,
                yAxis: yAxis,
                title: title,
                series: series,
                arr: arr
            };

        } else {
            return null;
        }
    };

    var pie = function (data, obj) {
        var elem = $('#' + obj.id);
        var config = obj.config || {};
        var chartObj = {
            credits: {
                enabled: false
            },
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false
            },
            title: {
                useHTML: true,
                text: data.title,
                style: {
                    display: obj.type == 'groupchart' ? '' : 'none'
                }
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.y}</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: obj.cursor ? 'pointer' : 'default',
                    dataLabels: {
                        enabled: true,
                        formatter: function() {
                            return this.y;
                        },
                        distance: -30,
                        color: '#FFF'
                    },
                    showInLegend: true
                }
            },
            navigation: {
                buttonOptions: {
                    enabled: false
                }
            },
            series: [{
                    type: 'pie',
                    name: data.title,
                    data: data.arr,
                    point: {
                        events: {
                            click: formatQueryAndOpenUrl.bind(obj)
                        }
                    }
                }]
        };

        if (!$.isEmptyObject(config.chart)) {
            $.extend(true, chartObj, config.chart);
        }

        elem.highcharts(chartObj);

    };

    var line = function (data, obj) {
        var elem = obj.parentName? $("#ez-dashboard-charts-" + obj.parentName).find("#" + obj.id): $('#' + obj.id);
        var config = obj.config || {};
        var chartObj = {
            credits: {
                enabled: false
            },
            title: {
                useHTML: true,
                text: data.title,
                x: -20 //center
            },
            xAxis: {
                categories: data.xAxis,
                allowDecimals: config.allowDecimals || false
            },
            yAxis: {
                title: {
                    text: config.yAxisLabel || ' Items',
                },
                plotLines: [{
                    value: 0,
                    width: 1,
                    color: '#808080'
                }],
                min: 0
            },
            tooltip: {
                valueSuffix: ''
            },
            plotOptions: {
                series: {
                    cursor: obj.cursor ? 'pointer' : 'default',
                    point: {
                        events: {
                            click: formatQueryAndOpenUrl.bind(obj)
                        }
                    }
                }

            },
            navigation: {
                buttonOptions: {
                    enabled: false
                }
            },
            series: data.series
        };

        if (!$.isEmptyObject(config.chart)) {
            $.extend(true, chartObj, config.chart);
        }

        elem.highcharts(chartObj);

    };
    
    var bar = function (data, obj) {
        var elem = obj.parentName? $("#ez-dashboard-charts-" + obj.parentName).find("#" + obj.id): $('#' + obj.id);
        var config = obj.config || {};
        var chartObj = {
            credits: {
                enabled: false
            },
            chart: {
                type: 'bar'
            },
            title: {
                useHTML: true,
                text: data.title,
                align: 'center',
                style: {
                    fontWeight: 'bold',
                    display: obj.config.subtitle ? '' : 'none'                    
                }
            },
            xAxis: {
                allowDecimals: config.allowDecimals || false,
                categories: data.xAxis
            },
            subtitle : {
                text : obj.config.subtitle,
                align: 'center',
                verticalAlign: 'bottom',
                floating: true,
                
                y: -20
            },
            yAxis: {
                min: 0,
                allowDecimals: config.allowDecimals || false,
                title: {
                    text: config.yAxisLabel || ' Items',
                    align: 'high'
                  },
                labels: {
                    overflow: 'justify'
                }
            },
            tooltip: {
                formatter: function(){
                    var item = config.tooltipSuffix || (this.y > 1 ? 'Items' : 'Item');
                    return this.x + '<br>' + this.series.name + ': <b>' + this.y + ' ' + item + '</b>';
                }
            },
            legend: {
                reversed: true
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
                        color: '#FFF',
                        formatter: function(){
                            var val = this.y;
                            if (val <= 0) {
                                return '';
                            }
                            return val;
                        }
                    }
                },
                series: {
                    fillOpacity: 0.1,
                    cursor: obj.cursor ? 'pointer' : 'default',
                    stacking: obj.type == 'barchart' ? null : 'normal',
                    point: {
                        events: {
                            click: formatQueryAndOpenUrl.bind(obj)
                        }
                    }
                }
            },
            navigation: {
                buttonOptions: {
                    enabled: false
                }
            },
            series: data.series
        };

        if (!config.negative) {
            chartObj.yAxis.min = 0;
        }

        if (!$.isEmptyObject(config.chart)) {
            $.extend(true, chartObj, config.chart);
        }

        elem.highcharts(chartObj);

    };

    var pagePriority = function (data, obj) {
        var elem = obj.parentName? $("#ez-dashboard-charts-" + obj.parentName).find("#" + obj.id): $('#' + obj.id);
        var config = obj.config || {};
        var chartObj = {
            credits: {
                enabled: false
            },
            chart: {
                type: 'bar'
            },
            title: {
                useHTML: true,
                text: data.title,
                align: 'center',
                style: {
                    fontWeight: 'bold',
                    display: ''                    
                }
            },
            xAxis: {
                allowDecimals: config.allowDecimals || false,
                categories: data.xAxis,
                labels: {
                    enabled: true,
                    formatter: function() {
                        var toolTip = "";
                        switch(this.value){
                            case "Content Health" : toolTip = '<span title="' + obj.config.xAxisTooltip[0] +'">' + this.value + '</span>';
                                break;
                            case "KW Pages": toolTip = '<span title="' + obj.config.xAxisTooltip[1] +'">' + this.value + '</span>';
                                break;
                            case "Traffic": toolTip = '<span title="' + obj.config.xAxisTooltip[2] +'">' + this.value + '</span>';
                                break;
                            case "Revenue": toolTip = '<span title="' + obj.config.xAxisTooltip[3] +'">' + this.value + '</span>';
                                break;
                        }
                        return toolTip;
                        
                    },
                    useHTML: true
                }
            },
            subtitle : {
                text : obj.config.subtitle,
                align: 'center',
                verticalAlign: 'bottom',
                floating: true,
                
                y: -20
            },
            yAxis: {
                min: 0,
                allowDecimals: config.allowDecimals || false,
                title: {
                    text: config.yAxisLabel || ' Items',
                    align: 'high'
                  },
                labels: {
                    overflow: 'justify'
                }
            },
            tooltip: {
                formatter: function(){
                    var item = config.tooltipSuffix || (this.y > 1 ? 'Items' : 'Item');
                    if(this.point.isInactive) {
                        return 'Please integrate analytics to view traffic and revenue scores:' + $.ezdia.config.pageParams.deskUrl + 'CreateNewSite.htm';
                    } if(this.point.noBarLegends) {
                        return false;
                    }else if (this.y >= 0) {
                        return this.x + '<br>' + this.series.name + ': <b>' + this.y + ' ' + item + '</b>';
                    }
                }
            },
            legend: {
                reversed: true
            },
            plotOptions: {
                bar: {
                    minPointLength:3,
                    dataLabels: {
                        enabled: true,
                        color: '#FFF',
                        formatter: function(){
                            var val = this.y;
                            if (val <= 0 || this.point.noBarLegends) {
                                return '';
                            }
                            return val;
                        }
                    }
                },
                series: {
                    fillOpacity: 0.1,
                    cursor: obj.cursor ? 'pointer' : 'default',
                    stacking: obj.type == 'barchart' ? null : 'normal',
                    point: {
                        events: {
                            click: formatQueryAndOpenUrl.bind(obj)
                        }
                    }
                }
            },
            navigation: {
                buttonOptions: {
                    enabled: false
                }
            },
            series: data.series
        };

        if (!config.negative) {
            chartObj.yAxis.min = 0;
        }

        if (!$.isEmptyObject(config.chart)) {
            $.extend(true, chartObj, config.chart);
        }

        elem.highcharts(chartObj);

    };

    var column = function (data, obj) {
        var elem = obj.parentName? $("#ez-dashboard-charts-" + obj.parentName).find("#" + obj.id): $('#' + obj.id);
        var config = obj.config || {};
        var chartObj = {
            credits: {
                enabled: false
            },
            chart: {
                type: 'column'
            },
            title: {
                useHTML: true,
                text: data.title
            },
            xAxis: {
                allowDecimals: config.allowDecimals || false,
                categories: data.xAxis
            },
            yAxis: {
                allowDecimals: config.allowDecimals || false,
                title: {
                    text: config.yAxisLabel || ' Items',
                    align: 'high'
                },
                labels: {
                    overflow: 'justify'
                }
            },
            tooltip: {
                formatter: function(){
                    var item = config.tooltipSuffix || (this.y > 1 ? 'Items' : 'Item');
                    return this.x + '<br>' + this.series.name + ': <b>' + this.y + ' ' + item + '</b>';
                }
            },
            legend: {
                reversed: true
            },
            plotOptions: {
                column: {
                },
                series: {
                    fillOpacity: 0.1,
                    cursor: obj.cursor ? 'pointer' : 'default',
                    point: {
                        events: {
                            click: formatQueryAndOpenUrl.bind(obj)
                        }
                    }
                }
            },
            navigation: {
                buttonOptions: {
                    enabled: false
                }
            },
            series: data.series
        };

        if (config.pointWidth) {
            chartObj.plotOptions.series.pointWidth = config.pointWidth;
        }

        if (!config.negative) {
            chartObj.yAxis.min = 0;
        }

        if (config.stacking) {
            chartObj.plotOptions.column.stacking = config.stacking;
        }

        if (!$.isEmptyObject(config.chart)) {
            $.extend(true, chartObj, config.chart);
        }

        elem.highcharts(chartObj);

    };
    
    
    var combinedchart = function(data,obj){
        var elem = obj.parentName? $("#ez-dashboard-charts-" + obj.parentName).find("#" + obj.id): $('#' + obj.id);
        var config = obj.config || {};
        var chartObj = {
            credits: {
                enabled: false
            },
            chart: {
                type: 'column'
            },
            title: {
                useHTML: true,
                text: data.title
            },
            xAxis: {
                allowDecimals: config.allowDecimals || false,
                categories: data.xAxis
            },
            yAxis : data.yAxis,
            legend: {
                reversed: true
            },
            plotOptions: {
                column: {
                },
                series: {
                    fillOpacity: 0.1,
                    cursor: obj.cursor ? 'pointer' : 'default',
                    point: {
                        events: {
                            click: formatQueryAndOpenUrl.bind(obj)
                        }
                    }
                }
            },
            navigation: {
                buttonOptions: {
                    enabled: false
                }
            },
            series: data.series
        };

        if (config.pointWidth) {
            chartObj.plotOptions.series.pointWidth = config.pointWidth;
        }


        if (config.stacking) {
            chartObj.plotOptions.column.stacking = config.stacking;
        }

        if (!$.isEmptyObject(config.chart)) {
            $.extend(true, chartObj, config.chart);
        }

        elem.highcharts(chartObj);
    }

    var timeSeries = function (data, obj) {
        var elem = $('#' + obj.id);
        var config = obj.config || {};
        var chartObj = {
            credits: {
                enabled: false
            },
            chart: {
                zoomType: 'x'
            },
            title: {
                useHTML: true,
                text: data.title
            },
            xAxis: {
                allowDecimals: config.allowDecimals || false,
                type: 'datetime'
            },
            yAxis: {
                allowDecimals: config.allowDecimals || false,
                title: {
                    text: config.yAxisLabel || ' Items',
                    align: 'high'
                },
                labels: {
                    overflow: 'justify'
                }
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                area: {
                    marker: {
                        radius: 2
                    },
                    lineWidth: 1,
                    states: {
                        hover: {
                            lineWidth: 1
                        }
                    },
                    threshold: null
                }
            },
            navigation: {
                buttonOptions: {
                    enabled: false
                }
            },
            series: data.series
        };

        if (!$.isEmptyObject(config.chart)) {
            $.extend(true, chartObj, config.chart);
        }

        elem.highcharts(chartObj);

    };

    var donut = function(data, obj){
        var elem = $('#' + obj.id);
        var config = obj.config || {};
        var chartObj = {
            credits: {
                enabled: false
            },
            chart: {
                type: 'pie',
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false
            },
            title: {
                useHTML: true,
                text: data.title
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.y}</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        color: '#000000',
                        connectorColor: '#000000',
                        format: '<b>{point.name}</b>: {point.y}'
                    }
                },
                series: {
                    cursor: 'pointer',
                    point: {
                        events: {
                            click: formatQueryAndOpenUrl.bind(obj)
                        }
                    }
                }
            },
            navigation: {
                buttonOptions: {
                    enabled: false
                }
            },
            series: [{
                name: data.title,
                data: data.series.inner,
                size: '60%',
                dataLabels: {
                    color: 'white',
                    distance: -30,
                    enabled: true
                }
            }, {
                name: data.title,
                data: data.series.outer,
                size: '80%',
                innerSize: '60%'
            }]
        };

        if (!$.isEmptyObject(config.chart)) {
            $.extend(true, chartObj, config.chart);
        }

        elem.highcharts(chartObj);

    };
    
    var chartSummary = function (data, obj) {
        var htmlContent = [];
        
        if(data) {
            htmlContent.push('<tr>');
            if(data.title) {
              htmlContent.push('<th colspan="2" class="summary-heading">' + data.title + '</th>');
            }
            htmlContent.push('</tr>');

            data = data.arr;
            
            if(data.Data) {
                $.each(data.Data, function(i, mval){
                    htmlContent.push('<tr>')
                    $.each(mval, function(j, val){
                      htmlContent.push('<td class="summary-data">' + val + '</td>')
                    })
                    htmlContent.push('</tr>')
                });
            
            }
            if (htmlContent.length) {
              htmlContent = '<table class="table chart-summary">' + htmlContent.join('') + '</table>';
            } else {
              htmlContent = htmlContent.join('');
            }

            $('#' + obj.id).html(htmlContent);
        }
    }

    var hollowDonut = function(data, obj){
      var elem = $('#ez-legends-' + data.title);
      var config = obj.config || {};
      var chartObj = {
          credits: {
              enabled: false
          },
          chart: {
              type: 'pie',
              plotBackgroundColor: null,
              plotBorderWidth: null,
              plotShadow: false,
              align: 'left',
              marginTop: 0,
              marginBottom: 0
          },
          title: {
              text: data.title,
              align: 'left',
              style: {
                  fontWeight: 'normal',
                  fontSize: '18px',
                  fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
                  display: ''
              }
          },
          tooltip: {
              pointFormat: '{series.name}: <b>{point.y}</b>'
          },
          plotOptions: {
              pie: {
                  allowPointSelect: true,
                  cursor: 'pointer',
                  dataLabels: {
                      enabled: false
                  },
                  showInLegend: true  
              },
              series: {
                  cursor: 'pointer',
                  point: {
                      events: {
                          click: formatQueryAndOpenUrl.bind(obj)
                      }
                  }
              }
          },
          legend: {
            enabled: true,
            layout: 'vertical',
            align: 'left',
            verticalAlign: 'top',
            itemMarginBottom: 5,
            useHTML: true,
            y: 32,
            x: 0,
            labelFormatter: function() {
                return '<span style="display:inline-block;margin-right:10px;font-weight:bold">' + this.name + '</span><span>' + this.y + '</span>';
            }
          },
          navigation: {
              buttonOptions: {
                  enabled: false
              }
          },
          series: [{
            type: 'pie',
            name: data.title,
            data: data.arr,
            size: '100%',
            innerSize: '80%'
        }]
      };

      if (!$.isEmptyObject(config.chart)) {
          $.extend(true, chartObj, config.chart);
      }

      elem.highcharts(chartObj);

  }; 

    var geo = function (data, obj) {
        google.load("visualization", "1.1", {packages: ["corechart"], callback: function(){
            var chartdata = obj.google.visualization.arrayToDataTable(data.arr);
            var options = {
                title: data.title
            };
            var geochart = new google.visualization.GeoChart(document.getElementById(obj.id));
            geochart.draw(chartdata, options);

        }});
    };

    var getSVG = function(charts) {
        var svgArr = [];
        var top = 0;
        var width = 0;
        var height = 0;
        var template = $.ezdia.template.get('dashboard-charts-export');
        var context = {};

        $.each(charts, function(i, chart) {
            var container = $(chart.container);
            var svg = chart.getSVG({
                chart: {
                    width: container.width(),
                    heigth: container.height()
                }
            });
            var height = parseInt(svg.match(/height="([0-9]+)"/)[1]);
            width = parseInt(svg.match(/width="([0-9]+)"/)[1]);

            svg = svg.replace('<svg', '<g transform="translate(0,' + top + ')" ');
            svg = svg.replace('</svg>', '</g>');

            top += height;

            svgArr.push(svg);
        });

        height = top + 30;
        context = {
            height: height,
            width: width,
            charts: svgArr,
            top: top
        };

        return template(context);
    };

    var overlay = function(id, cover, type){
        if (type != 'groupchart') {
            id.closest('div[data-row="panel"]').addClass('ez-chart-empty-panel');
        }

        if (cover) {
            var wrapper = $('<div>', {
               class: 'ez-chart-overlay'
            });
            var wrapper_sibliing = '<div class="ez-chart-overlay-content"><div class="chart-overlay-child"><span class="fa fa-bar-chart-o"></span><span>No data yet to display<span></span></div></div>';
            if(id.find(".ez-chart-overlay-content").length) {
              id.find('.ez-chart-overlay,.ez-chart-overlay-content').show();
            } else {
               id.append(wrapper);
               id.append(wrapper_sibliing);
            }
        }
    };
    
    function setFilterObjInLs(obj) {
        var config = obj.config || {};
        
        if (!config.filter) {
            return;
        }
        
        $.each(config.filter, function(name, query) {
            var ssQuery = sessionStorage.getItem(name);
            if (ssQuery) {
                sessionStorage.removeItem(name);
            }
            try {
                var queryString = JSON.stringify(query);
                localStorage.setItem(name, queryString);
            } catch (ex) {
                console.warn(ex);
            }
        });
    }

    $.extend(this, {
        chart: {
            create: function (dataObj, obj, parentID) {
                var data = formatData.call(this, dataObj, obj);
                parentID = parentID? parentID : $('#' + obj.id).parent()[0].id;
                var id = $('#' + parentID).find('#' + obj.id).empty().removeClass('ez-chart-empty');

                if(dataObj.helperText) {
                    id.next('.optional-descriptive').html(dataObj.helperText);
                }
                
                var copyObj = Object.assign({}, obj);
                
                if(dataObj.wType == "combined") {
                        data.series = data.series[0].data;
                        data.yAxis = dataObj.config ? JSON.parse(dataObj.config).yAxis : {};  
                        copyObj.type = "combinedchart";
                        if( dataObj.series && dataObj.series.disableLiveItems) {
                          data.yAxis = data.yAxis[0];
                          data.series.forEach(function(element) {
                            element.yAxis = 0; });
                            $("#"+ obj.id).closest(".ez-tab-container").find("input[type=checkbox]").attr("disabled",true);
                            $("#"+ obj.id).closest(".ez-tab-container").find(".noPublishingHistory").show();
                        } else {
                          var keywordRank = data.yAxis[0];
                          data.yAxis[0] = data.yAxis[1];
                          data.yAxis[1] = keywordRank;
                          data.yAxis[1].max = JSON.parse(dataObj.config).max;
                        }
                    }

                if (data) {
                    setFilterObjInLs(copyObj);
                    if(obj.config.chartType) {
                        copyObj.type = obj.config.chartType;
                    }
                    switch (copyObj.type) {
                        case 'chart':
                        case 'groupchart':
                            isChartEmpty = false;
                            if( dataObj.popupLegends ) {
                              $('#' + parentID +' .ez-legends-summary').empty();
                              var templateWrapper = $.ezdia.template.get(
                                'reporting-charts-legends-wrapper',
                                {}
                              );
                              $('#' + parentID +' .ez-legends-summary').append(
                                templateWrapper(data)
                              ).show();

                              var legendsChartData;
                              
                              $.each(dataObj.popupDetails, function(i, legendsData) {
                                legendsData.colModel =  dataObj.colModel;
                                legendsData.colNames =  dataObj.colNames;
                                legendsData.type = "donutchart";
                                legendsChartData = formatData.call(this,legendsData, obj);
                                hollowDonut.call(this, legendsChartData, copyObj);
                              });
                              
                            }
                            pie.call(this, data, copyObj);
                            break;
                        case 'linechart':
                            line.call(this, data, copyObj);
                            break;
                        case 'customBarChart':
                            pagePriority.call(this, data, copyObj);
                            break;
                        case 'barchart':
                        case 'stackedchart':
                            bar.call(this, data, copyObj);
                            break;
                        case 'columnchart':
                            column.call(this, data, copyObj);
                            break;
                        case 'combinedchart':
                            combinedchart.call(this, data, copyObj);
                            break;
                        case 'timeserieschart':
                            timeSeries.call(this, data, copyObj);
                            break;
                        case 'geochart':
                            geo.call(this, data, copyObj);
                        case 'donutchart':
                            donut.call(this, data, copyObj);
                            break;
                        case 'chartsummary':
                            chartSummary.call(this, data, copyObj);
                            break;
                        default:
                            break
                    }
                    if (copyObj.sample) {
                      $('#' + parentID).find("#ez-tab-" + obj.name).data("noData", true);
                        if( copyObj.type == "linechart" || copyObj.type == "columnchart" || copyObj.type == "combinedchart" || copyObj.type == "stackedchart") {
                          parentID = $("#" + parentID).find(".ez-dashboard-charts");
                          overlay.call(this, parentID, true, copyObj.type);
                        } else {
                          if(dataObj.popupLegends) {
                            $('#' + parentID +' .ez-legends-summary .ez-dashboard-reporting-popup-chart').remove();
                            $('#' + parentID +' .ez-charts-summaryTable').css("pointer-events", "none");
                          }
                          overlay.call(this, id, true, copyObj.type);
                        }
                    }
                } else {
                    $('#' + parentID).find("#ez-tab-" + obj.name).data("noData", true);
                    if(obj.type == 'groupchart') {
                        obj.started = true;
                        copyObj.started = true;
                    } else if(obj.type == 'chartsummary') {
                      $('#' + copyObj.id).html("No data to display");
                      return;
                    }
                    if( copyObj.type == "linechart" || copyObj.type == "columnchart" || copyObj.type == "combinedchart" || copyObj.type == "stackedchart") {
                      parentID = $("#" + parentID).find(".ez-dashboard-charts");                    
                      this.noData(parentID, copyObj.started);
                    } else {
                      this.noData(id, copyObj.started);
                    }
                }
                obj.started = true;
                copyObj.started = true;
            },
            groupChart: function (dataObj, obj) {
                var self = this;
                var id = $('#' + obj.id);
                var started = false;
                isChartEmpty = true;

                $('#' + obj.id).removeClass('ez-chart-empty');
                $.each(dataObj, function (i, grpObject) {
                    if(!i) return true;
                    self.create(grpObject, grpObject.obj);
                });

                started = id.data('started');

                if(isChartEmpty && !started) {
                    id.closest('div[data-row="panel"]').addClass('ez-chart-empty-panel');
                }

                id.data('started', true);
            },
            export: function(charts, options) {
                var form;
                var svg = getSVG(charts);

                // merge the options
                options = Highcharts.merge(Highcharts.getOptions().exporting, options);

                // create the form
                form = Highcharts.createElement('form', {
                    method: 'post',
                    action: options.url
                }, {
                    display: 'none'
                }, document.body);

                // add the values
                Highcharts.each(['filename', 'type', 'width', 'svg'], function(name) {
                    Highcharts.createElement('input', {
                        type: 'hidden',
                        name: name,
                        value: {
                            filename: options.filename || 'chart',
                            type: options.type,
                            width: options.width,
                            svg: svg
                        }[name]
                    }, null, form);
                });

                form.submit();

                // clean up
                form.parentNode.removeChild(form);
            },
            loading: function (id) {
                var template = $.ezdia.template.get('dashboard-loading-charts-wrapper');
                $(id).html(template());
            },
            noData: function (id, started) {
                var msg = '<i class="fa fa-bar-chart-o"></i> No data to display';
                var elem = (id instanceof jQuery) ? id : $(id);

                elem.empty().addClass('ez-chart-empty').html(msg);

                if (!started) {
                    overlay.call(this, elem, false);
                }
            },
            formatData: formatData,
            formatQueryAndOpenUrl: formatQueryAndOpenUrl
        }
    });
}).apply($.ezdia, [jQuery]);

(function ($) {

    var create = function (data, obj) {
        var elem = $('#' + obj.id);
        var template = $.ezdia.template.get('dashboard-rss-feed');
        var content = [];

        $.each(data, function (i, e) {
            var temp = {
                link: e.link,
                title: e.title,
                author: e.author,
                content: e.content,
                date: e.publishedDate
            };
            content.push(temp);
        });

        elem.html(template(content));
    };

    $.extend(this, {
        rss: function (dataObj, obj) {
            var url = dataObj.response ? dataObj.response : null;

            $.ajax({
                url: document.location.protocol + '//ajax.googleapis.com/ajax/services/feed/load?v=1.0&num=10&callback=?&q=' + encodeURIComponent(url),
                dataType: 'json',
                async: false,
                success: function (response) {
                    if (response.responseData.feed && response.responseData.feed.entries) {
                        create(response.responseData.feed.entries, obj);
                    }
                },
                error: function (response) {

                }
            });
        }
    });
}).apply($.ezdia, [jQuery]);

(function ($) {
    var clswarning = 'bg-warning';
    var clsdanger = 'bg-danger';
    var clssuccess = 'bg-success';
    var clsdangerText = 'text-danger';

    var colMatch = function (elem,json) {
        var value = elem.val();
        var row = elem.closest('tr');
        if(value){
            var editObj = json[value];
            var name = elem.attr("data-index");
            var configColumn = '[name="'+name+'.configColumn"]';
            var parentConfig = '[name="'+name+'.parentConfig"]';
            var newColumnName = '[name="'+name+'.newColumnName"]';
            var columnLabel = '[name="'+name+'.columnLabel"]';
            var editType = '[name="'+name+'.editType"]';
            $(configColumn).val(editObj.configColumn);
            $(parentConfig).val(editObj.parentConfig);
            $(newColumnName).val(editObj.name);
            $(columnLabel).val(editObj.label);
            $(editType).val(editObj.type);
        }
        if (!value) {
            row.addClass(clswarning).attr('data-empty', true);
        };

        row.data('value', value);

    };

    var ignoreColumns = function () {
        $('#uploadExcelTable').on('click', 'input[type="checkbox"]', function () {
            var elem = $(this);
            var name = this.name;
            var selectId = name.split('.')[0];
            var row = elem.closest('tr');
            var value = null;

            selectId = selectId.replace('[', '').replace(']', '');

            if (elem.is(':checked')) {
                row.addClass(clsdanger).removeAttr('data-empty').data('ignore', true);
            } else {
                value = $('#' + selectId).val();
                if (!value) {
                    row.addClass(clswarning).attr('data-empty', true);
                }
                row.removeClass(clsdanger).data('ignore', false);
            }
        });
    };

    var selects = function (elem) {
        if (elem.find('option').length > 5) {
            elem.selectmenu();
        }
    };

    var onchange = function(json){
        var elem = $(this);
        var row = elem.closest('tr');
        var value = elem.val();
        var preVal = row.data('value');
        var editObj = json[value];
        var name = elem.attr("data-index");
        var configColumn = '[name="'+name+'.configColumn"]';
        var parentConfig = '[name="'+name+'.parentConfig"]';
        var newColumnName = '[name="'+name+'.newColumnName"]';
        var columnLabel = '[name="'+name+'.columnLabel"]';
        var editType = '[name="'+name+'.editType"]';

        if (!value) {
            var ignore = row.data('ignore');
            if(!ignore) {
                row.addClass(clswarning).attr('data-empty', true);
            }
        } else if(preVal != value){
            row.addClass(clssuccess).removeClass(clswarning).removeAttr('data-empty');
        } else {
            row.removeClass(clssuccess).removeAttr('data-empty');
        }

        $(configColumn).val(value ? editObj.configColumn : '');
        $(parentConfig).val(value ? editObj.parentConfig : '');
        $(newColumnName).val(value ? editObj.name : '');
        $(columnLabel).val(value ? editObj.label : '');
        $(editType).val(value ? editObj.type : '');

    };

    var getBtnPos = function(btn){
        var pos = btn.offset();
        var width = btn.outerWidth();

        return {
            left: pos.left + width/2 + 'px',
            top: pos.top + 'px'
        };
    };

    var createErrorMsg = function(obj, btn){
        var template = $.ezdia.template.get('error');
        var pos = getBtnPos(btn);
        var context = {
            arr: [],
            left: pos.left,
            top: pos.top
        };
        var content = null;

        $.each(obj.rows, function(index){
            var row = $(this);
            var txt = row.find('td').eq(0).text();

            context.arr.push({
                label: txt.trim(),
                cls: obj.cls,
                msg: obj.msg,
                index: index
            });

        });

        content = template(context);
        $('#ez-error-msg-container').html(content).off('click').on('click', 'a[data-index]', function(){
            var elem = $(this);
            var index = elem.data('index');
            var row = $(obj.rows[index]);
            var prefix = row.data('index');
            $.ezdia.scrollTo(row);

            setTimeout(function() {
                $('#columnMatcher'+prefix).focus();
            }, 600);

        });
    };

    $.extend(this, {
        import: {
            init: function (arr,json) {
                $.each(arr, function (i, mval) {
                    var elem = $('#' + mval);
                    elem.change(function(){
                        onchange.call(this, json);
                    });
                    colMatch(elem,json);
                    sortAccountName(mval);
                    selects(elem);

                });
                ignoreColumns();
            },
            validate: function(frm, e){
                var row = frm.find('tr[data-empty]');
                var empty = frm.find('tr[data-empty]').length;
                var btn = $(e.currentTarget);

                if (empty) {
                    createErrorMsg({
                        rows: row,
                        cls: clsdangerText,
                        msg: 'Please select available field value or select ignore columns.'
                    }, btn);
                    return false;
                } else {
                    return true;
                }
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function ($) {
    var arr;
    var eventType = '.ez.quickActionLinks';

    var selectLink = function (elem) {
        var isDD = elem.data('dd');
        
        if (isDD) {
            ezdia.component.quickActions.setSelection(elem);
            return;
        }
        
        elem.parents('li').addClass('active').siblings().removeClass('active');
    };

    var resetQuickActionLink = function () {
      ezdia.component.quickActions.resetQuickActionLink();
    };

    var toogleDisplay = function(){
        var selIds = getGridSelRow();
        var grid = $('#grid');

        if (selIds.length == 1) {
            selIds = parseInt(selIds[0]);
            //Don't remove these line of code.
            grid.jqGrid('setSelection', selIds, true);
            grid.jqGrid('setSelection', selIds, true);
            //End
        } else if (selIds.length) {
            hideShowDeskForm('');
            resetQuickActionLink();
        }

    };

    var getItems = function (data) {
        if (typeof data === 'string' || $.isEmptyObject(data)) {
            return false;
        }

        $.each(data, function (i, obj) {

            var item = {
                type: obj.name,
                id: $.ezdia.sanitizer.specialChar(obj.name),
                disabled: true,
                min: obj.minItems,
                max: obj.maxItems
            };

            switch (obj.name) {
                case 'sys_show_all_ids':
                    item.label = obj.title || 'Show All IDs';
                    item.disabled = false;
                    item.min = 0;
                    item.max = 0;
                    item.items = {
                        "sys_all_ids": {
                            type: "sys_all_ids",
                            label: "Show All IDs"
                        },
                        "sys_selected_ids": {
                            type: "sys_selected_ids",
                            label: "Show Selected IDs"
                        }
                    };
                    if (obj.selectShowFields) {
                        $.extend(item.items, obj.selectShowFields);
                        item.actionUrl = obj.actionUrl;
                    }
                    break;
                case 'sys_user_work_profile':
                    item.label = 'User Work Profile';
                    break;
                case 'sys_assignment_limit':
                    item.label = 'Assignment Limit';
                    break;
                case 'sys_assignment_time_limit':
                    item.label = 'Assignment Time Limit';
                    break;
                case 'sys_open_projects':
                    item.label = 'Show Open Projects';
                    break;
                case 'sys_open_proj_default_rule':
                    item.label = 'Add Open Project Default Rule';
                    break;
                case 'sys_copy_org_users':
                    item.label = 'Copy to another Organization';
                    break;
                case 'sys_send_email':
                    item.label = 'Send Email';
                    break;
                case 'sys_change_pwd':
                    item.label = 'Change Password';
                    break;
                case 'sys_checkout_items':
                    item.label = 'Checkout Items';
                    item.disabled = false;
                    item.min = 0;
                    item.max = 0;
                    break;
                case 'sys_invoice_completed_batch':
                    item.label = 'Show Completed Batches';
                    item.disabled = false;
                    item.min = 0;
                    item.max = 0;
                    break;
                case 'sys_share_items_approval':
                case 'sys_share_items':
                    item.label = obj.btnlabel;
                    break;
                default:
                    if (obj.selectShowFields) {
                        item.type = "sys_show_dropdown";
                        item.label = obj.title;
                        item.disabled = false;
                        item.min = 0;
                        item.max = 0;
                        item.items = obj.selectShowFields;
                        item.actionUrl = obj.actionUrl;
                    } else if (!$.isEmptyObject(obj.quickActionFields)) {
                        //item.label = obj.btnlabel;
                        item.label = obj.title;
                        item.title = obj.title;
                    } else {
                        item = '';
                    }
                    break
            }
            if (item) {
                arr.push(item);
            }
        });

        if ($.isEmptyObject(arr)) {
            arr = false;
        }
    };

    var getMarkup = function () {
        var partial = {
            'quickLinks': 'quick-action-links'
        };
        var template = $.ezdia.template.get('quick-links-panel', partial);
        var context = '';
        if (!$.isEmptyObject(arr)) {
            context = template({
                label: 'Quick Actions',
                type: 'quickLinks',
                id: 'ez-quick-action-links',
                links: arr
            });
        }
        return context;
    };

    var notInRange = function (rangeObj) {
        var returnVal = false;
        var selectedItemsLen = 0;

        if (!rangeObj.min && !rangeObj.max) {
            returnVal =  false;
        } else {
            var selectAll = $('#selectAll').is(':checked');
            var selIds = [];

            if (selectAll) {
                // selIds = $.ezdia.config.pageParams.tab === 'MyTask' ? getAllItemIds() : $.ezdia.storeForm.getAllItemIds();
                selectedItemsLen = $("#grid").jqGrid('getGridParam', 'records');
            } else {
                selIds = getGridSelRow();
                selectedItemsLen = selIds.length;
            }

            // var selectedItemsLen = selIds.length;
            var min = rangeObj.min;
            var max = rangeObj.max;

            if (min && min > selectedItemsLen) {
                minmaxAlert('min', min);
                returnVal = true;
            } else if (max && max < selectedItemsLen) {
                minmaxAlert('max', max);
                returnVal = true;
            }
        }

        return returnVal;
    };

    var minmaxAlert = function (type, count){
        var wrap = $.ezdia.getWrapper('ez-js-sys-quick-action-min-max-selection');
        var msg = '';

        if (type === 'min') {
            msg = 'You need to have at least ' + count + ' item(s) to be selected for this Quick Action.';
        } else if (type === 'max') {
            msg = 'You can have at most ' + count + ' item(s) selected for this Quick Action.';
        }

        wrap.html(msg);
        wrap.dialog({
            modal: true,
            title: 'Item selection error',
            width: 450,
            height: 200,
            buttons: [{
                text: "Cancel",
                class: 'btn-link',
                click: function() {
                    $(this).dialog("close");
                }
            }]
        });
    };

    var quickAction = function (currentAction) {
//        var elem = $(e.currentTarget);
//        var id = elem.attr('id');
//        var type = elem.data('type');
//        var select = true;
//        var viewType = elem.data('viewType');
//        var active = elem.data('active');
//        var min = elem.data('min');
//        var max = elem.data('max');
//        var selectRange = {
//            min: min,
//            max: max
//        };
//
//        if (/MSIE/.test(navigator.userAgent) && !parseInt(active)) {
//            return false;
//        } if (notInRange(selectRange)) {
//            return false;
//        }
//
//        elem.button('loading');
//
//        if ((select && elem.closest('li').hasClass('active')) || (viewType === 'button' && elem.hasClass('active'))) {
//            elem.button('reset');
//            resetQuickActionLink();
//            toogleDisplay();
//            
//            if(min == 0) {
//                var selectAll= $('#selectAll').is(':checked');
//                var ids = getGridSelRow();
//
//                if (!selectAll && !ids.length) { 
//                    ezdia.component.form.hide();
//                }
//                
//            }
//            return false;
//        }

        //setTimeout(function(){
        
        var id = 'ez-quick-link-' + currentAction.id;
        var type = currentAction.type;
        
        switch (type) {
            case 'sys_share_items':
                $.ezdia.shareLiveLink.create(id, false);
                select = false;
                break;
            case 'sys_user_work_profile':
                userWorkProfileQAClick();
                break;
            case 'sys_share_items_approval':
                $.ezdia.shareLiveLink.create(id, true);
                select = false;
                break;
            case 'sys_send_email':
                sendEmailQuickActionClick();
                break;
            case 'sys_show_all_ids':
            case 'sys_show_dropdown':
                this.openIdsList(id);
                select = false;
                break;
            case 'sys_all_ids':
            case 'sys_selected_ids':
                this.getAllIdsList(type);
                select = false;
                break;
            case "sys_selected_show_fields":
                this.getAllFieldList(currentAction);
                select = false;
                break;
            case 'sys_assignment_limit':
                //assignmentLimitQuickActionClick();
                $.ezdia.assignmentLimit.create();
                break;
            case 'sys_assignment_time_limit':
                //assignmentTimeLimitQAClick();
                $.ezdia.assignmentTimeLimit.create();
                break;
            case 'sys_open_projects':
                //showOpenProjQuickActionClick();
                $.ezdia.quickActionOpenProject.create();
                break;
            case 'sys_open_proj_default_rule':
                //openProjDefRuleQAClick();
                $.ezdia.quickActionOpenProjectDefRule.create();
                break;
            case 'sys_change_pwd':
                changePasswordQAClick();
                break;
            case 'sys_copy_org_users':
                copyOrgUsersQAClick();
                select = false;
                break;
            case 'sys_checkout_items':
                checkoutItemsQAClick();
                break;
            case 'sys_invoice_completed_batch':
                $.ezdia.quickActionInvoiceBatch.create();
                break;
            case 'mark_invoiced':
                select = $.ezdia.quickAction.markInvoiced(id, type);  
                break;  
            case 'eza_send_for_optimization':
            case 'eza_mark_added':
                ezdia.component.quickActions.popupQuickActions(type);
                select = false;
                break; 
            case 'eza_share':
            case 'eza_share_query':
                ezdia.component.quickActions.popupQuickActionForm(type);
                select = false;
                break;
            case 'ga_alert_export':
            case 'ga_archive_export':
                ezdia.pages.ezAnalytics.export(type);
                // $.ezdia.quickAction.load(id, type, null , null , undefined , true);
                break;
            default:
                $.ezdia.quickAction.load(id, type);
                break
        }

//        if (select) {
//            selectLink(elem);
//        }
//
//        elem.button('reset');
//
//        if (e.target.nodeName == 'I') {
//            setTimeout(function(){
//                elem.parent().addClass('open');
//            }, 0);
//        }
    };

    var allIdsList = function (data, obj) {
        var html = '';
        obj = obj || {};

        $.ajax({
            type: "POST",
            url: obj.actionUrl || "listItemIds.htm",
            data: data,
            dataType: 'json',
            success: function (response) {
                var ids =  response;

                if (typeof response === "string") {
                    ids =  response ? response.split(',') : [];
                }

                if (!ids.length) {
                    return alert("No data found", "No data found.");
                }

                var plural = ids.length > 1 ? "s" : "";

                if (obj.title) {
                    html = "<b>" + obj.title + plural + ": </b>" + ids.join(', ');
                } else {
                    if(document.queryCommandSupported('copy')) {
                        html = "<b>Total selected items: </b>" + ids.length + "</br></br><b>Selected Ids: </b>" + ids.join(', ')+
                            '<button data-button="copy" type="button" class="btn btn-link copy-ids" title="Copy all ids"><i class="fa fa-copy"></i></button>'+
                            '<input class="copy-text-box" type="text" id="ezdia-copy-field" value="' + 
                            ids.join(', ') +'">';
                    } else {
                        html = "<b>Total selected items: </b>" + ids.length + "</br></br><b>Selected Ids: </b>" + ids.join(', ');
                    }
                    
                }
                               
                var wrapper = $.ezdia.getWrapper('statusMsg');
                
                wrapper.html(html);
                
                wrapper.find('[data-button="copy"]').on('click', function() {
                    var copyText = document.getElementById("ezdia-copy-field");
                    copyText.select();
                    document.execCommand("copy");
                    $.ezdia.showSuccessError({
                        message: 'Ids copied to clipboard'
                    });       
                });

                wrapper.dialog({
                    modal: true,
                    title: obj.title || 'Item IDs',
                    width: 450,
                    height: 400,
                    buttons: {
                        Ok: function () {
                            $(this).dialog("close");
                        }
                    }
                });
            },
            error: function () {
                alert("Error", "Error generating Ids list.");
            }
        });
    };

    $.extend(this, {
        quickLinks: {
            create: function (data, items, isDropDown) {
                var context = '';
                arr = items || [];
                getItems(data);
                if (arr) {
                    context = isDropDown ? ezdia.component.quickActions.render(arr) : getMarkup();
                }
                return context;
            },
            quickAction: function (currentAction, e) {
               quickAction.call(this, currentAction, e);
            },
            triggersAction: function (e) {
               ezdia.component.quickActions.handelOnClick(e);
               // quickAction.call(this, e);
            },
            triggersActive: function (id) {
                $(id).off(eventType)
                        .on('click' + eventType, 'a:not([data-active])', $.proxy(this.triggersAction, this));
            },
            triggersOn: function (id) {
                $(id).off(eventType)
                    .on('click' + eventType, 'a', $.proxy(this.triggersAction, this))
                    .find('a[data-active]').removeClass('disabled').data('active', '1');
                resetQuickActionLink();
            },
            triggersOff: function (id) {
                $(id).off('a[data-active]' + eventType).find('a[data-active]').addClass('disabled').data('active', '0');
                resetQuickActionLink();
            },
            openIdsList: function (id) {
                var elem = $('#' + id);
                var scroll = $(window).scrollTop();
                var pos = elem.offset();
                var dropdown = elem.next('ul');

                dropdown.css({
                    left: pos.left,
                    top: pos.top - scroll
                });
            },
            getAllFieldList: function (currentAction) {
                var pageParams = $.ezdia.config.pageParams || {} ;
                var selectAll= $('#selectAll').is(':checked');
                var ids = getGridSelRow();

                if (selectAll || ids.length) {
                    var label = currentAction.label;
                    label = label ? decodeURIComponent(label) : '';
                    var actionUrl = currentAction.actionurl;
                    var searchStr = getSearchQueryString();
                    var data = "&accountName=" + $('#accountName').val();
                    data += "&roleName=" + $('#role').val();
                    data += "&fieldName=" + currentAction.name;
                    data += "&searchString=" + searchStr;
                    data += '&formtype=' + pageParams.formType || '';
                    data += '&searchCondition=' + searchStr;
                    allIdsList(data, {
                        actionUrl: actionUrl,
                        title: label
                    });
                } else {
                    alert("Item IDs", "Please select at least one item");
                }

            },
            getAllIdsList: function(type){
                var text = '';
                var selectAll= $('#selectAll').is(':checked');

                if(type === 'sys_all_ids' || selectAll) {
                    var data = "&accountName=" + $('#accountName').val();
                    data += "&roleName=" + $('#role').val();
                    data += "&searchString=" + getSearchQueryString();
                    allIdsList(data);
                } else {
                    var ids = getGridSelRow();

                    if (ids.length) {
                        text = "<b>Total selected items: </b>" + ids.length + "</br></br><b>Selected Ids: </b>" + ids.join(', ');
                    } else {
                        text = "Please select at least one item";
                    }

                    $("#statusMsg").html(text);
                    $("#statusMsg").dialog({
                        modal: true,
                        title: 'Item IDs',
                        width: 450,
                        height: 400,
                        buttons: {
                            Ok: function () {
                                $(this).dialog("close");
                            }
                        }
                    });
                }

            },
            notInRange: function (rangeObj) {
                return notInRange(rangeObj);
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function ($) {
    var loadingID = 'ez-sys-grid-item-loading';
    var writingTips = [
        "Compound nouns can be open, hyphenated and closed.",
        "Work during the time of day when you’re at your most creative and focused. Don’t try to trudge through those times when you can’t focus.",
        "Observe the world around you for inspiration. The people and activities you see can provide you with great inspiration for characters, plots and themes (and features and benefits!)",
        "Grammar: learn the rules and then learn how to break them effectively.",
        "Read works by respected authors so you can learn how to be a better writer.",
        "Try turning off chat and social media when you sit down to work; you’ll get more done in less time when you’re not multitasking.",
        "Do you know how to detect passive voice…with zombies? Check the forums for a great link!",
        "Fresh eyes are a writer’s best friend. Try doing a batch of work, and then saving it. Come back several hours later or first thing in the morning to read through it — you’ll catch your own mistakes and earn better ratings!",
        "Hyphens matter. Improve your quality by mastering the art and science of the hyphen.",
        "Hey, has anybody told you that you’re awesome today? Well, you’re awesome!",
        "The pen (or keyboard) is mightier than the sword, but if you only have a pen and the other guy has a sword, your best option is to run. :p "
    ];

    var getValue = function (arr) {
        var template = $.ezdia.template.get('grid-loading');
        var text = '';
        var loading = true;

        if (arr) {
            text = arr[Math.floor(Math.random() * arr.length)];
            loading = false;
        }

        var context = {
            text: text,
            loading: loading
        };

        return template(context);
    };

    $.extend(this, {
        loading: {
            default: function () {
                return getValue();
            },
            writingTips: function () {
                return getValue(writingTips);
            },
            create: function () {

                if ($('#' + loadingID).length) {
                    return;
                }

                var template = $.ezdia.template.get('grid-item-loading');
                var content = template({
                    sys_hb_id: loadingID
                });

                $('body').append(content);
            },
            show: function () {

                if (!$('#' + loadingID).length) {
                    this.create();
                }

                $('body').addClass('show-loading').css({
                    overflow: 'hidden'
                });
            },
            hide: function () {
                $('body').removeClass('show-loading').css({
                    overflow: ''
                });
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function ($) {

    var toggle = function () {
        var ul = $(this);
        var btn = ul.parents('div[data-row="panel"]')
                .find('a.ez-show-more-quick-links').hide();
        var sHeight = this.scrollHeight;

        if (sHeight <= 39) {
            return false;
        }

        btn.css('display', 'block')
        sHeight = this.scrollHeight;

        btn.off('click').on('click', function () {
            var elem = $(this);
            var less = elem.hasClass('less');
            var height = elem.data('height');

            if (less) {
                elem.removeClass('less');
            } else {
                height = sHeight;
                elem.addClass('less');
            }

            ul.animate({
                'height': height
            }, 'fast', function () {
                if (!less) {
                    ul.css({
                        'height': 'auto'
                    });
                }

            });
        });
    };

    var getShowLink = function () {
        $('[data-link="showMore"]').each(function () {
            toggle.call(this);
        });
    };

    var onWindowResize = function () {
        $(window).resize(function () {
            getShowLink();
        });
    };

    $.extend(this, {
        showMorelinks: function () {
            getShowLink();
            onWindowResize();
        }
    });
}).apply($.ezdia, [jQuery]);

(function ($) {
    var config = null;
    var partialShareMarkup = {
        'shareItemTable': 'share-items-link-email-table',
        'sharedItemMobileMenu': 'shared-live-links-item-menu-mobile'
    };

    var getLabel = function (label) {
        return label || 'Share Url';
    };

    var getHref = function (mval, ids) {
        var url = config.deskUrl + 'ViewContent.htm';
        return url + "?key=" + mval + "&taskId=" + ids + "&accountName=" + config.account;
    };

    var getEmailHref = function (mval, ids) {
        var url = config.deskUrl + 'ViewContent.htm';
        return url + "?key=" + mval + "&taskId=" + ids + "&accountName=" + config.account;
    };

    var sendEmail = function (obj) {
        var _this = this;
        var form = $('#ez-email-share-form');

        if(!form.valid()){
            return;
        }

        $.ezdia.loading.show();

        form.ajaxSubmit({
            type: "POST",
            url: "emailShareItemLinks.htm",
            dataType: 'text',
            beforeSubmit: function (arr) {
                arr.push({
                    name: 'roleName',
                    value: config.role
                }, {
                    name: 'accountName',
                    value: config.account
                }, {
                    name: 'taskId',
                    value: obj.id
                });
            },
            success: function (response) {
                $.ezdia.loading.hide();
                $(_this).dialog( "close" );
                $.ezdia.showSuccessError({
                    message: response
                });
            },
            error: function (response) {
                $.ezdia.loading.hide();
                $.ezdia.showSuccessError({
                    message: response,
                    error: true
                });
            }

        });
    };

    var shareCcBcc = function (e) {
        var elem = $(e.currentTarget);
        var type = elem.data('send');
        var input = null;

        if (type == 'cc') {
            input = $('#ez-share-email-cc');
        } else if (type == 'bcc') {
            input = $('#ez-share-email-bcc');
        }
        input.show();
        elem.hide();
    };

    var buildEmailBody = function () {
        var key = 'ez-share-email-input-email-' + config.module;
        var htmlEditorArray = {};
        var metadata = {
            content_template_name: ["Writing Trial Results", "Writing Trial Lingering"]
        };
        buildHTMLElement(htmlEditorArray, '', metadata, key, '');
        createHTMLElement({
            htmlEditorArray: htmlEditorArray,
            convertUrls: true
        });
    };

    var shareMenuActions = function (e) {
        var elem = $(e.currentTarget);
        var type = elem.data('click');
        var id = elem.data('id');
        var feedback = elem.data('feedback');

        if (type === 'email') {
            var data = {
                elem: $('#ez-shared-link-' + config.module + '-' + id),
                feedback: feedback
            };
            createEmailPreview(data, false);
        } else {
            createMobilePreview(e);
        }

    };

    var createEmailPreview = function (data, error) {
        var module = config.module;
        var template = $.ezdia.template.get('share-items-link-email', partialShareMarkup);
        var elem = data.elem;
        var feedback = data.feedback;
        var context = {};
        var email = elem.data('email');
        var link = elem.attr('href');

        if (error) {
            context = {
                message: data.ERROR,
                error: error
            };
        } else {
            if (feedback) {
                email += "&feedback=true";
            } else {
                link = link.replace('&feedback=true', '&feedback=false');
                email += "&feedback=false";
            }
            context = {
                module: module,
                error: error,
                link: link,
                label: elem.text()
            };
        }

        createSharePanel({
            htmls: template(context),
            data: {
                id: elem.data('key'),
                email: email
            }
        });

    };

    var createSharePanel = function (obj) {
        var panel = $('#ez-share-item-email-wrapper');

        if (!panel.length) {
            var div = $('<div>', {
                id: 'ez-share-item-email-wrapper'
            });
            $('body').append(div);
            panel = $('#ez-share-item-email-wrapper');
        }

        panel.html(obj.htmls);
        panel.dialog({
            modal: true,
            title: 'Share Links',
            width: 800,
            height: 600,
            buttons: [{
                text: "Cancel",
                class: 'btn-link',
                click: function() {
                    $(this).dialog( "close" );
                }
            }, {
                id: 'ez-share-email-item-button',
                text: "Share Via email",
                click: function() {
                    var listBlock = $('#ez-email-share-item-list');
                    if (listBlock.is(':visible')) {
                        listBlock.hide();
                        $('#ez-email-share-form').show();
                        $('#ez-share-email-item-button').text('Share');
                    } else {
                        sendEmail.call(this, obj.data);
                    }
                }
            }]
        }).off('click').on('click', 'a[data-click]', shareMenuActions)
                .on('click', 'a[data-send]', shareCcBcc);

        buildEmailBody();
        validateEmailForm();
    };

    var validateEmailForm = function () {
        $('#ez-email-share-form').validate({
            rules: {
                shareEmail: {
                    required: true,
                    email: true
                },
                emailSubject: {
                    required: true
                }
            },
            errorPlacement: function (error, element) {
                $.ezdia.validateForm.errorPlacement(error, element);
            },
            highlight: function (element) {
                $.ezdia.validateForm.highlight(element);
            },
            unhighlight: function (element) {
                $.ezdia.validateForm.unhighlight(element);
            }
        });
    };

    var getDisplayMarkup = function (data) {
        var partial = {
            'shareItem': 'shared-live-links-item',
            'menu': 'shared-live-links-item-menu'
        };
        var template = $.ezdia.template.get('share-item-links-panel', partial);
        var context = {
            module: config.module,
            type: 'shareItem',
            label: 'Share Item Live Link',
            items: getDisplayContext(data)
        };

        return template(context);

    };

    var getDisplayContext = function (data) {
        var items = [];
        var ids = data.ids;

        $.each(data.value, function (key, mval) {

            if (key !== "ERROR") {
                var href = getHref(mval.key, ids) + '&feedback=true';
                var emailLink = getEmailHref(mval.key, ids);
                var label = mval.label || 'Share Url';

                items.push({
                    module: config.module,
                    key: ids,
                    label: label,
                    href: href,
                    email: emailLink
                });
            } else {
                items.push({
                    error: true
                });
            }
        });

        return items;
    };

    var getShareContext = function (data) {
        var items = [];
        var str = '';

        $.each(data.value, function (key, mval) {

            if (key !== "ERROR") {
                var href = getHref(mval.key, key);
                var email = getEmailHref(mval.key, key);
                var label = getLabel(mval.label);

                if (data.feedback) {
                    href += "&feedback=true";
                    email += "&feedback=true";
                } else {
                    href += "&feedback=false";
                    email += "&feedback=false";
                }

                email = key + ' : <a href="' + email + '" target="_blank" class="share-link">' + label + '</a><br/><br/>';

                items.push({
                    module: config.module,
                    key: key,
                    label: label,
                    href: href
                });

                str += email;
            } else {
                items = false;
                str = mval;
            }
        });

        return {
            items: items,
            email: str
        };

    };

    var getShareMarkup = function (obj) {
        var template = $.ezdia.template.get('share-items-link-email', partialShareMarkup);
        var list = getShareContext(obj);
        var context = {};
        if (!list.items) {
            context = {
                message: list.email,
                error: true
            };

        } else {
            var emailTemplate = $.ezdia.template.get('shareitems', null, true, 'email');
            var emailContent = '';

            if(emailTemplate) {
                emailContent = emailTemplate({
                    userName: config.userName,
                    email: config.email,
                    organization: config.orgLabel,
                    org_admin_email: config.orgAdmin,
                    org_email_footer: config.orgEmailFooter,
                    detail: list.email,
                    CURRENT_YEAR: (new Date()).getFullYear()
                });
            } else {
                emailContent = list.email;
            }

            context = {
                module: config.module,
                view: 'table',
                emailContent: emailContent,
                items: list.items
            };
        }

        createSharePanel({
            htmls: template(context),
            panelSize: 'big',
            data: {
                id: obj.ids,
                email: list.email
            }
        });

    };

    var generateLinks = function (obj) {

        $.ajax({
            type: "POST",
            url: "createShareLinks.htm",
            data: obj.data,
            dataType: 'json',
            success: function (response) {
                getShareMarkup({
                    value: response,
                    ids: obj.ids,
                    feedback: obj.feedback
                });
            },
            error: function () {

            }
        }).always(function () {
            obj.btn.button('reset');
        });
    };

    $.extend(this, {
        shareLiveLink: {
            display: function (obj) {
                config = $.ezdia.config.pageParams;
                var context = null;
                var data = obj.data || {};
                var shareObj = data.shareItem;

                if (shareObj && !shareObj.ERROR) {

                    context = getDisplayMarkup({
                        value: shareObj,
                        ids: obj.ids
                    });

                    $(obj.container).html(context).on('click', 'a[data-click]', shareMenuActions);
                }
            },
            create: function (btnId, feedback) {
                config = $.ezdia.config.pageParams;

                var selIds = getGridSelRow();
                var selectAll = $('#selectAll').is(':checked');
                var btn = $('#' + btnId);

                btn.button('loading');

                if (!selectAll && (!selIds || selIds.length == 0)) {
                    alert("Error", "Please select at least one item");
                    btn.button('reset');
                    return;
                }

                if (selectAll) {
                    selIds = getAllItemIds();
                }

                var data = "&accountName=" + config.account;
                data += "&roleName=" + config.role;
                data += "&taskId=" + selIds;

                generateLinks({
                    data: data,
                    ids: selIds,
                    btn: btn,
                    feedback: feedback
                });

            }
        }
    });
}).apply($.ezdia, [jQuery]);

// (function ($) {

//     $.extend(this, {
//         basicSearch: {
//             createSelect: function () {
//                 var acc = $('select#accountName');
//                 var role = $('select#role');

//                 if (acc.length) {
//                     acc.sortItems().chosen({
//                         placeholder_text: '',
//                         disable_search_threshold: 8
//                     });
//                 }

//                 if (role.length) {
//                    role.sortItems().chosen({
//                         placeholder_text: '',
//                         disable_search_threshold: 8
//                     });
//                 }

//             }
//         },
//         advancedSearch: {
//             createSelect: function () {
// //                $('#SearchFieldGroup').on('mouseover', 'select:not([data-menu="active"])', function () {
// //                    var self = $(this);
// //                    $(this).sortItems().chosen({
// //                        placeholder_text: '',
// //                        disable_search_threshold: 10
// //                    });
// //                    $(this).attr('data-menu', 'active');
// //                });
//             }
//         }
//     });
// }).apply($.ezdia, [jQuery]);

(function ($) {
    var debug = false;

    var metaObject = function (column) {
        var obj = {};
        var metadata = column.metadata || column.addon;

        if (!metadata) {
            return null;
        } else if (column.edittype == 'json') {
            return metadata;
        } else if (typeof metadata === 'string') {
            if (column.edittype == 'tab' || column.edittype == 'composite') {
                obj.fields = metadata.split(",");
            } else {
                $.each(metadata.split(','), function (i, mval) {
                    var temp = [];
                    var key = null;
                    var value = null;

                    if (mval.indexOf("##") !== -1) {
                        obj.options = {};
                        $.each(mval.split("##"), function (i, opt) {
                            var temp = opt.toLowerCase();
                            if (temp == 'other' && (column.edittype == 'singlechoice' || column.edittype == 'multichoice')) {
                                obj.userInput = true;
                            } else {
                                obj.options[opt] = opt;
                            }
                            ;
                        });
                    } else if (mval.indexOf(":") === -1) {
                        obj[mval] = true;
                    } else {
                        temp = mval.split(":");
                        key = temp[0];
                        value = temp[1];

                        switch (key) {
                            case 'cssCls':
                                obj[key] = value;
                                break;
                            case 'rows':
                                obj[key] = value;
                                break;
                            case 'height':
                                obj[key] = value;
                                break;
                            case 'width':
                                obj[key] = value;
                                break;
                            case 'min':
                                obj[key] = value;
                                break;
                            case 'max':
                                obj[key] = value;
                                break;
                            default:
                                if (!obj[key]) {
                                    obj[key] = [];
                                }
                                obj[key].push(value);
                                break
                        };
                    }
                });
            }
            metadata = obj;
        }

        if(debug){
            console.log(metadata);
        }

        return metadata;
    };

    var customerConfig = function(config){
        var json = {};

        $.each(config, function(key, value){
            switch (key) {
                case 'charcount_min_count':
                case 'charcount_min_tooltip':
                case 'charcount_min_message':
                case 'charcount_min_type':
                case 'charcount_max_count':
                case 'charcount_max_tooltip':
                case 'charcount_max_message':
                case 'charcount_max_type':
                case 'charcount_disable':
                case 'charcount_ignore_html':
                case 'wordcount_min_count':
                case 'wordcount_min_tooltip':
                case 'wordcount_min_message':
                case 'wordcount_min_type':
                case 'wordcount_max_count':
                case 'wordcount_max_tooltip':
                case 'wordcount_max_message':
                case 'wordcount_max_type':
                case 'wordcount_disable':
                    setCustomerConfig(json, key, value);
                    delete config[key];
                    break;
                default:
                    break;
            }
        });

        if (!$.isEmptyObject(json)) {
            $.each(json, function(key, obj){
                config[key] = obj;
            });
        }

        if(debug){
            console.log(config);
        }

        return config;
    };

    var setCustomerConfig = function(json, key, value){
        var arr = key.split('_');
        var last = arr[arr.length - 1];

        $.each(arr, function(i, name){
            name = name.toLowerCase();

            if (typeof json[name] === 'undefined') {
                if (last == name){
                    json[name] = value;
                } else {
                    json[name] = {};
                }
            }
            json = json[name];
        });
    };

    $.extend(this, {
        getFieldsConfig: function (column) {
            debug = $.ezdia.checkurl('debug=true');

            if (column.config) {
                if (typeof column.config === 'string' && $.trim(column.config)) {
                    column.config = $.ezdia.getJsonObject(column.config);
                }
                return column.config;
            }
            column.config = metaObject(column);

            return column.config;
        },
        getCustomerConfig: function(config){
            return customerConfig(config);
        }
    });
}).apply($.ezdia, [jQuery]);

$.ezdia.getContentTemplate();

(function ($) {
    var config = null;
    var status = null;
    var steps = null;
    var action = null;
    var source = null;
    var taskFlowName = null;

    var getData = function(data, currentStep){
        var context = {};
        status = currentStep;
        $.each(data, function(key, value){
            if (key == 'label') {
                context.label = value;
            } else if (key == 'currentStep') {
                status = value;
            } else if (key == 'steps') {
                steps = value;
            } else if (key == 'name') {
                taskFlowName = value;
            } else if (key == 'source') {
                source = value;
                $.ezdia.steps.options.source = value;
	    }
        });

        context.steps = getSteps(steps);

        return context;
    };

    var getSteps = function(data){
        var arr = [];
        var index = 1;
        var done = true;
        var tempBackObj = {
            url: source,
            label: 'Back to Source'
        };

        $.each(data, function(key, obj){
            var active = false;
            var back = null;


            if (status == key) {
                active = true;
                action = obj.actions;
                done = false;
                back = tempBackObj;
            } else if (!active) {
                tempBackObj = {
                    url: "javascript:window.history.go(-1)",
                    label: 'Back to Step '+ index + ': ' + obj.label
                };
            }

            arr.push({
                key: key,
                label: obj.label,
                help: obj.help,
                back: active && back,
                index: index++,
                active: active,
                done: done
            });
        });

        return arr;
    };

    var getFieldsData = function(fields, data){
        var arr = [];

        if(data) {
            $.each(data, function(i, obj){
                if ($.inArray(obj.name, fields) !== -1) {
                    arr.push(obj);
                }
            });
        }
        return arr;
    };

    var getButtons = function(btn){
        var arr = [];

        $.each(btn, function(key, obj){
            arr.push(obj);
        });

        return arr;
    };

    var getPageData = function(stepdata, data){
        var context = {};
        var arr = [];
        var index = 1;

	var keyLen = Object.keys(stepdata.steps).length;
        $.each(stepdata.steps, function(key, obj){

            if (obj.page_header) {
                context.heading = obj.page_header;
                context.action = getButtons(obj.actions);
                return true;
            }
            arr.push({
                name: key,
                heading: obj.label,
                url: index-keyLen,
                index: index++,
                fields: getFieldsData(obj.confirm_page_fields, data[key])
            });

        });
        context.block = arr;
        $.ezdia.steps.options.source = stepdata.steps[status].actions.cancel.confirm_action_url;

        return context;

    };

    var bindEvents = function() {
        $.each(action, function(key, obj){
            $('#'+ obj.id).off('click').on('click', function(e){
                var elem = $(e.currentTarget);
                var form = elem.parents('form');
                var name = elem.attr('name');

                if(name == 'submitDetails') {
                    $.ezdia.steps.saveConfirm();
                } else if (name == 'cancel' || name == 'cancelbtn') {
		    $.ezdia.steps.cancelFlow();
                } else {
                    $.ezdia.steps.save(form, key, obj);
                }

           });
        });
    };

    var saveConfirmAjaxSuccess = function(response) {
        var url = steps[status].actions.submit.confirm_action_url;

        window.location.href = url;
    };

    $.extend(this, {
        steps: {
	    options: {
		source: null
	    },
            create: function (data, currentStep) {
                config = $.ezdia.config.pageParams;
                var template = $.ezdia.template.get('task-steps');
                var context = getData(data, currentStep);
                var elem = $('#ez-task-steps-block');

                elem.append(template(context));
                bindEvents.call(this);
            },
            confirm: function (stepdata, data, id) {
                var template = $.ezdia.template.get('task-steps-confirm');
                var context = getPageData(stepdata, data);
                $(id).html(template(context));
                bindEvents.call(this);
            },
            save: function (form, btnKey, obj) {
                var frmId = form.attr('id');
                config = $.ezdia.config.pageParams;
                form.ajaxSubmit({
                    type: "POST",
                    url: "TaskFlow.htm",
                    dataType: 'json',
                    beforeSubmit: function (arr) {
                        arr.push({
                            name: 'role',
                            value: config.role
                        }, {
                            name: 'accountName',
                            value: config.account
                        }, {
                            name: 'taskFlowName',
                            value: taskFlowName
                        }, {
                            name: 'btnType',
                            value: btnKey
                        }, {
			    name: 'currentStep',
			    value: obj.next
			});
                    },
                    success: function (response) {
                        $.ezdia.widgetsInstance.clearAll(frmId);
                        hideShowDeskForm();
                        var url = response.redirectUrl;
                        window.location.href = url;
                    },
                    error: function (err) {
                        var url = "MyAccount.htm";
                        window.location.href = url;
                    }
                });
            },
            saveConfirm: function () {
                config = $.ezdia.config.pageParams;
		var paramMap = JSON.parse(config.taskFlowParamMap);
		var actionMap = JSON.parse(config.stepActions);

		if(paramMap && actionMap) {
                    this.activeAjaxRequests = 0;

		    $.each(paramMap, function (key, obj) {
                        var value = actionMap[key];
                        if (value) {
                            $.ezdia.steps.saveConfirmAjax(obj, value);
                        }
		    });
		}
            },
            saveConfirmAjax: function (data, url) {
                var _this = this;

                $.ajax({
                    type: "POST",
                    url: url,
                    data: data,
                    dataType: 'text',
                    beforeSend: function () {
                        _this.activeAjaxRequests++;
                    },
                    success: function (response) {
                        _this.activeAjaxRequests--;

                        if (_this.activeAjaxRequests === 0) {
                            saveConfirmAjaxSuccess(response);
                        }

                    },
                    error: function (response) {
                        _this.activeAjaxRequests--;
                        console.log('err')
                    }
                });
            },
	    cancelFlow: function () {
		var url = $.ezdia.steps.options.source;
		$.ajax({
                    type: "POST",
                    url: "ConfirmTaskFlow.htm",
                    dataType: 'text',
                    success: function (response) {
			if(url) {
			    window.location.href = url;
			} else {
			    window.location.href = "Home.htm";
			}
                    },
                    error: function (response) {
			window.location.href = "Home.htm";
                    }
                });
            }
        }
    });
}).apply($.ezdia, [jQuery]);

(function ($) {

    $.extend(this, {
        createProject: {
            choose: function (data) {
                config = $.ezdia.config.pageParams;
                var template = $.ezdia.template.get('create-project-select');

                return template(data.projects);
            }
        }
    });

}).apply($.ezdia, [jQuery]);

(function ($) {

    var getWrapper = function(){
        var id = 'base-wrapper-type-modal';
        var elem = $('#' + id);

        if (!elem.length) {
            var div = $('<div>', {
                id: id
            });

            $('body').append(div);
            elem = $('#' + id);
        }

        return elem;
    };

    var readMore = function(obj) {
        var elem = $(this);
        var index = elem.data('index');
        var modalTemplate = $.ezdia.template.get('base-form-type-modal');
        var template = $.ezdia.template.get(obj.moretemplate || 'base-form-type-project-description');
        var item = obj.data[index];
        var wrapper = getWrapper();
        var id = elem.data('id') + index;
        item.media = $.ezdia.getJsonObject(item.media);

        var content = template(item);

        content = modalTemplate({
            id: id,
            content: content
        });

        wrapper.html(content);

        $('#' + id).modal().on('hidden.bs.modal', function () {
            wrapper.empty();
        });

        $('#ez-carousel-generic').carousel('pause');

    };

    $.extend(this, {
        cardLayout: {
            create: function (obj) {
                var template = $.ezdia.template.get(obj.template || 'card-layout');
                var content = template(obj.data);

                $(obj.container).html(content).masonry({
                   columnWidth: '.card-col',
                   itemSelector: '.card-col'
                }).on('click', '[data-read="more"]', function(){
                    readMore.call(this, obj);
                });
            }
        }
    });

}).apply($.ezdia, [jQuery]);

//(function ($) {
//    var pageParams = null;
//    var loadingID = 'ez-sys-grid-item-loading';
//
//    $.extend(this, {
//        grid: {
//            selectFirstItem: function (grid) {
//                pageParams = $.ezdia.config.pageParams;
//                var elem = (grid instanceof jQuery) ? grid : $(grid);
//                var id = elem.getDataIDs()[0];
//
//                if (id){
//                    elem.jqGrid('setSelection', id, true);
//                }
//
//                delete pageParams['sysSelectFirst'];
//            },
//            quickAction: function(id){
//                pageParams = $.ezdia.config.pageParams;
//                var action = $.ezdia.sanitizer.specialChar(pageParams.sysQuickAction);
//                var ids = $('#' + id).getDataIDs()[0];
//                var elem = null;
//
//                if(!ids && !ids.length){
//                    return false;
//                }
//
//                $('#selectAll').trigger('click');
//
//                elem = $('a[data-type="' + action.trim() +'"]');
//                if (elem.length) {
//                    elem.trigger('click');
//                }
//
//                delete pageParams['sysQuickAction'];
//            },
//            projectTypeView: function(v, frm){
//                var mapping = $.ezdia.config.PROJECT_TYPE_CSS_MAPPING;
//                var cls = "label " + (mapping[v] || 'label-default');
//                var label = '';
//
//                if (v) {
//                    label = $('<span>', {
//                        class: cls,
//                        text: v
//                    });
//                }
//
//                if (!frm) {
//                    var wrap = $('<div>', {
//                        class: "col-max-height",
//                        "data-value": v
//                    });
//                    wrap = wrap.append(label).prop('outerHTML');
//
//                    return wrap;
//                } else {
//                    return label.prop('outerHTML');
//                }
//            },
//	    accountTypeView: function(v){
//                var allProjects = $.ezdia.config.pageParams.allProjects || {};
//                var label = v;
//
//                var projects = JSON.parse(allProjects);
//                $.each(projects, function (key, accounts) {
//                    $.each(accounts, function (accName, accLabel) {
//                        if (accName === v) {
//                            label = accLabel;
//                            return false;
//                        }
//                    });
//                });
//
//                var wrap = $('<div>', {
//                    class: "col-max-height",
//                    "data-value": v,
//		    html: label
//                });
//
//                return wrap.prop('outerHTML');
//             },
//             loading: {
//                 create: function() {
//
//                     if ($('#' + loadingID).length){
//                         return;
//                     }
//
//                    var template = $.ezdia.template.get('grid-item-loading');
//                    var content = template({
//                        sys_hb_id: loadingID
//                    });
//
//                    $('body').append(content);
//                },
//                show: function() {
//                    $('body').addClass('show-loading').css({
//                        overflow: 'hidden'
//                    });
//                },
//                hide: function() {
//                    $('body').removeClass('show-loading').css({
//                        overflow: ''
//                    });
//                }
//             }
//        }
//    });
//
//}).apply($.ezdia, [jQuery]);

(function ($) {
    var self;
    var rowId = null;
    var typeAdd = 'additionalFields';
    var template = null;

    var wrapper = function (id) {
        var wrap = $('#' + id);

        if (!wrap.length) {
            var html = $('<div>', {
                id: id
            });

            //$('#access_by_group-main').after(html);
            wrap = $('#' + id);
        }

        return wrap;
    };

    var getValue = function (siteResp, column) {
        var value = '';

        $.each(siteResp, function (i, obj) {
            if (obj.id == rowId) {
                $.each(obj, function (key, mval) {
                    if (key == column.name) {
                        value = mval;
                    }
                });
            }
        });

        return value;
    };

    var appendContent = function (content) {
        var container = wrapper('createNewSite-additional-fields');

        container.html(content);
    };

    $.extend(this, {
        publishSites: {
            additionalFields: function (data, rowData, siteResp) {
                var content = '';
                self = this;
                template = $.ezdia.template.get('quick-action-form-row');

                if (data) {
                    $.ezdia.widgets.load(typeAdd);

                    rowId = rowData ? getColDataString('', rowData.id) : null;
                    $.each(data, function (i, column) {
                        var value = siteResp ? getValue(siteResp, column) : '';
                        var inputs = '';
                        var obj = {
                            column: column,
                            value: value
                        };

                        column.edittype = column.type;
                        column.editable = true;
                        column.config = $.ezdia.getFieldsConfig(column);

                        inputs = $.ezdia.inputs.create(obj, typeAdd);
                        content += self.markup(inputs, column);

                        $.ezdia.widgets.init(obj);
                    });
                }

                if (content) {
                    appendContent(content);
                    $.ezdia.widgets.create(typeAdd);
                }
            },
            markup: function (inputs, column) {
                var content = '';

                if (column.edittype == 'hidden') {
                    content = inputs;
                } else {
                    content = template(column);
                    content = $(content);
                    content.find('[data-row="input"]').append(inputs);
                    content = content.prop('outerHTML');
                }

                return content;
            }
        }
    });

}).apply($.ezdia, [jQuery]);

(function ($) {
    var pageParams = {};
    var formfixcls = 'ez-grid-form-active-fixed';

    var reset = function(){
        if (/MSIE/.test(navigator.userAgent) || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            tinyMCE.editors.length = 0;
        }
        $('#qaction_links > .active').removeClass('active');

    };

    toggleQuickLinks = function(clicked){
        var id = this.id;
        var checked = $('#cb_' + id).is(':checked');
        var selIds = ezdia.util.getSelectedGridItemsByGridId();

        if (!selIds.length) {
            $.ezdia.quickLinks.triggersOff('#ez-quick-action-links');
        } else if ((selIds.length == 1 && clicked) || checked){
            $.ezdia.quickLinks.triggersOn('#ez-quick-action-links');
        }
    };
    
    var resetGridWidthAndForm = function(isHideForm) {
//        var gridFormW = $('#ez-js-grid-form-wrapper');
//        
//        if (!gridFormW.length) {
//            return;
//        }
//        
//        var gridWidth = '375';
        
        if(isHideForm) {
            ezdia.component.form.hide()
//            gridWidth = $(document).width() - 32;
//            gridFormW.removeClass('ez-grid-form-active');
//            unbindScroll();
        } else {
            ezdia.component.form.show()
//            $('.ui-jqgrid-bdiv').scrollLeft(0);  
//            gridFormW.addClass('ez-grid-form-active');
//            scrollToForm();
        }
        
//        $('#grid').jqGrid('setGridWidth', gridWidth, false);

    };
    
    var scrollToForm = function() {
        bindScroll();
        $('html,body').animate({
            scrollTop: $("#ez-js-grid-form-wrapper").offset().top - 51
        }, 1000);        
    }
    
    var bindScroll = function() {
        var win = $(window);
        var frmw = $("#ez-js-grid-form-wrapper");
        
        win.off('scroll.ez.formscroll').on('scroll.ez.formscroll', function() {
            var formtop = frmw.offset().top;
            var wintop = win.scrollTop();
            if (formtop - wintop <= 51) {
                fixForm(frmw);
            } else {
                unfixForm(frmw);
            }
        });
    }
    
    var fixForm = function (frmw) {
        frmw.addClass(formfixcls);
        var outerH = $("#ez-js-form-top-info-and-nav").outerHeight();
        $("#ez-js-form-top-info-and-nav-placeholder").css('height', outerH);
    }
    
    var unfixForm = function (frmw) {
        frmw.removeClass(formfixcls);
        $("#ez-js-form-top-info-and-nav-placeholder").css('height', 0);
    }
    
    var unbindScroll = function() {
        $(window).off('scroll.ez.formscroll');
        var frmw = $("#ez-js-grid-form-wrapper");
        unfixForm(frmw);
    }

    var renderForm = function(ids, clicked, e) {
        var isCBClick = ezdia.util.gridCBClick(event);
        var selIds = getGridSelRow();
        e = e || {};

        if (selIds && selIds.length > 1) {
            resetGridWidthAndForm();
            ezdia.component.quickActions.updateSelectedIdsOnView(selIds);
            hideShowDeskForm('#bulkEditFrm');
        } else if (ids && selIds.length === 1 && !isCBClick) {
            resetGridWidthAndForm();
            hideShowDeskForm();
            if (hasTableTypeField) {
                getItemDetail("id", ids);
            } else {
                if (!e.ctrlKey) {
                    ids = selIds.toString();
//                     var data = $("#grid").jqGrid('getRowData', ids);
//                     renderItemOnRowSelect(data, ids);
                    ezdia.component.form.renderItem({
                        ids: ids, 
                        grid: 'grid'
                    });
                }
                if (pageParams.account != "expert" && pageParams.roleType != "customer" && pageParams.roleType != "pm") {
                    var submitMultipleBtn = $('#submitMultipleBtn').hide();
                    var submitSingleBtn = $('#submitSingleBtn').hide();
                    var nextChild = $('#grid').find('tr.ui-state-highlight').next('tr');

                    if (nextChild.length) {
                        submitMultipleBtn.show();
                    } else {
                        submitSingleBtn.show();
                    }
                }
            }
        } else if (!selIds.length) {
            resetGridWidthAndForm(true);
            hideShowDeskForm('');
        }

        toggleQuickLinks.call(this, selIds, clicked);
    };

    // REMOVE IN FUTURE
    var reloadActiveMsg = function() {
        var wrapper = $.ezdia.getWrapper('ez-js-sys-desk-item-reload');

        wrapper.html('Changes on server are not synced with local data. Do you want to Sync it now?').dialog({
            modal: true,
            title: 'Sync Pending',
            width: 400,
            height: 200,
            buttons: [{
                text: "Close",
                class: 'btn-link',
                click: function() {
                    $( this ).dialog( "close" );
                }
            }, {
                text: "Sync Now",
                class: 'btn-primary',
                click: function() {
                    $( this ).dialog( "close" );
                    hideShowDeskForm();
                    selectAllClick();
                    $("#grid").trigger("reloadGrid");
                    $('#selectAll').prop('checked', false);
                }
            }]
        });
    };

    $.extend(this, {
        desk: {
            grid: {
                beforeSelectRow: function(rowid, e) {
                    var grid = $(this);
                    var row = $(e.target).closest('tr');
                    var selectAll;
                    var multiselect;

                    if (row.data('reload')) {
                        reloadActiveMsg();
                        selectAll = true;
                    } else {
                        multiselect = grid.jqGrid('getGridParam', 'multiselect');
                        selectAll = $('#selectAll').is(':checked');

                        if(isGridMultiSelect()) {
                            var isCheckbox = $(e.target).is(':checkbox');
                            var cbox = $(e.target).hasClass('cbox');
                            var ctrl = e.ctrlKey;
                            var targetCell = ($(e.target).attr('aria-describedby') === 'grid_cb') ? true : false;
                            if (grid.jqGrid("getGridParam", "selrow") !== rowid && !isCheckbox && !cbox && !ctrl && !targetCell) {
                                grid.jqGrid("resetSelection");
                            }
                        }

                        if (!multiselect && grid.jqGrid("getGridParam", "selrow") === rowid) {
                            grid.jqGrid('setGridParam', {'deselectrow': true});
                        }
                    }
                    
                    return !selectAll;
                },
                onSortCol: function (index, columnIndex, sortOrder) {
                    hideShowDeskForm();
                },
                toggleQuickLinks: function(clicked){
                    var selIds = getGridSelRow();
                    toggleQuickLinks(selIds, clicked);
                },
                resetGridWidthAndForm: function(isHideForm) {
                    resetGridWidthAndForm(isHideForm);
                    if(!isHideForm) {
                        toggleQuickLinks(false);
                    }
                    
                }
            },
            getMetaObj: function(obj) {
                var ids = obj.ids;
                var widgets = obj.widgets;
                var query = {};
                pageParams = $.ezdia.config.pageParams;

                if (pageParams.isMyTask) {
                    query = {
                        shareItem: {},
                        comments: {},
                        returnOptions: {}
                    };

                    if (pageParams.hasOpenProjectsRole) {
                        query.checkItemInQueue = {};
                    }
                }

                var metaObj = {};
                widgets = widgets || {};
                var briefObj = widgets.brief || pageParams.briefObj;
                var categoryObj = widgets.category || pageParams.category;
                var commentsObj = widgets.comment || pageParams.commentsObj;

                if(!$.isEmptyObject(commentsObj)){
                    commentsObj['_list'] = {};
                }

                if(!$.isEmptyObject(briefObj)){
                    if (briefObj.value) {
                        query.brief = {
                            name: encodeURIComponent(briefObj.value)
                        };
                    }
                    query.briefList = {};
                }

                if(!$.isEmptyObject(categoryObj)){
                    $.each(categoryObj, function(key, mobj){
                        if(mobj.value) {
                            query.category = {
                                id: mobj.value
                            };
                        }
                    });
                }

                if(!$.isEmptyObject(query)){
                    metaObj = checkItemMetaInfo(query);
                    $.ezdia.config.metaObj = metaObj;
                    ezdia.config.JS.itemMetaData = metaObj;

                    pageParams.briefList = metaObj.briefList;
                    pageParams.returnOptions = metaObj.returnOptions;
                    briefObj['_value'] = metaObj.brief || null;
                    commentsObj['_list'] = metaObj.comments || {};
                    ezdia.config.metadata = metaObj;

                }

            }
        }
    });

}).apply($.ezdia, [jQuery]);

Highcharts.theme = {
    colors: ['#03A9F4', '#8BC34A', '#FFC107', '#3F51B5', '#FF5722', '#00BCD4', '#E91E63', '#009688', '#795548', '#673AB7', '#2196F3',
        '#F44336', '#4CAF50', '#FF9800', '#9C27B0', '#607D8B', '#CDDC39', '#FFEB3B', '#9E9E9E', '#000000'],
    title: {
        style: {
            fontWeight: 'normal',
            fontSize: '14px',
            fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
            display: 'none'
        }
    },
    xAxis: {
        labels: {
          style: {
              fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
              fontSize: '12px'
          }
      },
        title: {
            style: {
                color: '#393939',
                fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
                fontWeight: 'normal'
            }
        }
    },
    yAxis: {
        gridLineColor: '#dddddd',
        labels: {
            style: {
                color: '#9b9b9b',
                fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif'
            }
        },
        title: {
            style: {
                color: '#393939',
                fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
                fontWeight: 'normal'
            }
        },
        min: 0
    },
    legend: {
         borderRadius: 0,
         borderWidth: 0,
         symbolRadius: 12,
         symbolWidth: 12,
         itemDistance: 15,
         itemMarginTop: 10
    }
};
// Apply the theme
Highcharts.setOptions(Highcharts.theme);

$.validator.addMethod("handlebars", function(value, element) {
    var error = true;
    try {

        value = $('<div>', {
            html: value
        }).text();

        Handlebars.compile(value)();
    } catch (err) {
        var len = err.message.indexOf('Expecting');
        err = err.message;

        if (len != -1) {
            err = err.substr(0, len);
        }

        err = 'Error in template: ' + err.replace(/\n/g,"<br />");
        $.extend($.validator.messages, {
            handlebars: err
        });
        error = false;
    }
    return this.optional( element ) || error;
}, 'Please correct the template.');

$.validator.addMethod("ezEmail", function(value, element) {
    if (value) {
        value = value.trim();
    }
    return this.optional( element ) || ( /^[a-z0-9]+([-._][a-z0-9]+)*@([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,4}$/.test( value ) && /^(?=.{1,64}@.{4,64}$)(?=.{6,100}$).*/.test( value ) );
}, 'Please enter valid email address.');

$.validator.addMethod("unique", function(value, element) {
    var error = true;
    var validate_key = $.ezdia.config.validate_key.unique;

    if (value) {
        var elem = $(element);
        var unique_array = elem.data(validate_key.key);
        var index = elem.data(validate_key.index);
        var unique_array_copy = unique_array.slice(0);
        var str = unique_array_copy.splice(index, 1);

        if (unique_array_copy.indexOf(str.join('')) !== -1) {
            error = false;
        }

    }

    return this.optional( element ) || error;

}, 'This value already taken');


$.validator.addMethod("reviewLabels", function(value, element) {
    var noError = true;
    
    if(value) {
        noError = $(element).entityLabeling('reviewLabels');
    }
    
    return this.optional( element ) || noError;
        
}, 'Please review all the labels in the Sentence field');
    
$.validator.addMethod("uniqueUserName", function(value, element) {
    var error = true;

    $.ajax({
        url: "fetchusers.htm?term=" + value,
        async: false,
        success: function(res) {
            $.each(res, function(i, obj) {
                if (obj.value === value) {
                    error = false;
                    return false;
                }
            });
        },
        error: function() {

        }
    });

    return this.optional( element ) || error;

}, 'A user with same email id already exists.');

$.validator.addMethod("multiemail", function (value, element) {
    if (this.optional(element)) {
        return true;
    }

    var emails = value.split(','),
        valid = true
        self = this;
    
    emails.forEach(function (email) {
        value = email.trim();
        valid = valid && $.validator.methods.email.call(self, value, element);
    });

    return valid;
}, "Please use a comma to separate multiple email addresses.");

//Handle 401 error

$( document ).ajaxError(function( event, jqxhr, settings, exception ) {
    if ( jqxhr.status === 401 ) {
        var wrap = $.ezdia.getWrapper('ez-js-sys-error-401');

        wrap.html('Your Session has been expired. Please login again.');
        wrap.dialog({
            closeOnEscape: false,
            open: function(e, ui) {
                $(".ui-dialog-titlebar-close", ui.dialog | ui).hide();
            },
            modal: true,
            title: 'Session timeout',
            width: 450,
            height: 200,
            buttons: [{
                text: "Login Again",
                class: 'btn-primary',
                click: function() {
                    window.location.href = 'Logout.htm';
                    $(this).dialog("close");
                }
            }]
        });

    }
});

(function ($, doc) {
    var isSubmitted = false;
    var submittedIndexs = [];
    var submittedIndexsCount = 0;
    var currentDataIndex = 0;
    var accountsObj = {};
    var rolesObj = {};
    var currentData = null;
    var ajaxData = null;
    var content = null;
    var workingHoursArray = [];

    var setAccountAndRoleObj = function () {

        $.each(ajaxData, function (i, obj) {
            var account = obj.account;
            var role = obj.role;

            accountsObj[account] = obj.accountLabel;

            if (!rolesObj[account]) {
                rolesObj[account] = {};
            }

            rolesObj[account][role] = obj.roleLabel;
        });
    };

    var getDate = function () {
        var dt = new Date();
        var date = moment(dt);

        return date.format("ddd LT");
    };

    var getDaysArray = function () {
        var arr = []

        for (i = 1; i <= 7; i++) {
            arr.push(moment().add(i, 'days').format('ddd'));
        }
        return arr;
    };

    var getFormattedDate = function(next) {
        return moment().add(next, 'days').format('YYYY-MM-DD');
    };

    var getDatesObj = function (goals) {
        var obj = {};

        for (var i = 0; i <= 7; i++) {
            var key = getFormattedDate(i);
            obj[key] = goals[key] || "";
        }

        return obj;
    };

    var event = function () {
        var _this = this;
        var planWeek = content.find("#plan-your-week");
        var planTomorrow = content.find("#plan-your-tomorrow");
        var accountSelect = content.find('[name="account"]');
        var roleSelect = content.find('[name="role"]');

        planWeek.on("click", function() {
            $(this).closest('[data-row="row"]').hide(0, null, function() {
                planTomorrow.closest('[data-row="row"]').show();
            });
        });

        planTomorrow.on("click", function() {
            $(this).closest('[data-row="row"]').hide(0, null, function() {
                planWeek.closest('[data-row="row"]').show();
            });
        });

        content.find('[data-type="numeric"]').numeric({
            decimal: false
        });

        accountSelect.on("change", function() {
            onChangeAccountOrRole.call(_this, $(this).val());
        });

        roleSelect.on("change", function() {
            onChangeAccountOrRole.call(_this, accountSelect.val(), $(this).val());
        });

        setTimeout(function() {
            accountSelect.chosen({
                placeholder_text: '',
                disable_search_threshold: 8
            });
            roleSelect.chosen({
                placeholder_text: '',
                disable_search_threshold: 8
            });
        }, 0);
    };

    var onChangeAccountOrRole = function (account, role) {
        var _this = this;

        $.each(ajaxData, function (i, obj) {
            if ((obj.account === account && !role) || (obj.account === account && obj.role === role)) {
                _this.dialog(i);
                return false;
            }
        });
    };

    var validate = function (goals) {
        var rules = {
            'working_hours': 'required'
        };

        $.each(goals, function (key) {
            rules[key] = isValidate();
        });

        $("#ezdia-week-plan-form").validate({
            "errorClass": "text-danger",
            "rules": rules,
            highlight: function(element) {
                if (element.name === "working_hours") {
                    $(element).parent().addClass("bg-danger");
                } else {
                    $(element).addClass("bg-danger");
                }

            },
            unhighlight: function(element) {
                $(element).removeClass("bg-danger").parent().removeClass("bg-danger");
                $("#" + element.name + "-error").remove();
            },
            errorPlacement: function (error, element) {
                if (element[0].name === "working_hours") {
                    element.closest('[data-row="input"]').append(error);
                } else if (element.data("name") !== "tomorrow_goal") {
                    $("#welcome-screen-week-goal-errors").append(error);
                } else {
                    element.after(error);
                }
            }
        });
    };
    var isValidate = function () {
        return {
            "required": isVisible,
            "number": isVisible
        };
    };

    var isVisible = function (element) {
        return $(element).closest('[data-row="row"]').is(":visible");
    };

    var dialog = function () {
        var wrapper = $.ezdia.getWrapper("ezdia-welcome-screen-wrapper");
        var buttons = [{
            html: "<i class='fa fa-video-camera'></i> Help",
            class: 'btn-link help-button-left',
            click: function() {
                window.open('//www.screencast.com/t/VKVsGGJE1t', '_blank');
            }
        }, {
            id: "ezdia-welcome-screen-close",
            text: "Cancel",
            class: 'btn-link',
            click: function() {
                $(this).dialog('close');
            }
        }, {
            text: "Submit",
            class: 'btn-primary',
            click: function() {
                ajaxPostData($(this));
            }
        }];

        wrapper.html(content);

        if (submittedIndexsCount > 1) {
            buttons.push({
                text: "Submit and next",
                class: 'btn-default',
                click: function() {
                    ajaxPostData($(this), true);
                }
            });
        }

        wrapper.dialog({
            closeOnEscape: false,
            open: function(e, ui) {

                $(".ui-dialog-title", ui.dialog | ui).css({
                    width: "100%"
                });
                $(".ui-dialog-titlebar-close", ui.dialog | ui).hide();
            },
            modal: true,
            title: 'Hello, lets\'s plan your work <span class="welcome-screen-date">' + getDate() + '</span>' ,
            width: 650,
            height: 475,
            buttons: buttons
        });

        if (!isSubmitted) {
            $('#ezdia-welcome-screen-close').hide();
        }

        var tomorrowGoalInput = wrapper.find('[data-name="tomorrow_goal"]');
        var tomorrowGoalVal = tomorrowGoalInput.val();

        tomorrowGoalInput.focus().val("").val(tomorrowGoalVal);
    };

    var getData = function (index) {
        var inc = 0;
        var obj = ajaxData[index];
        if (!obj) {
            return;
        }

        var data = $.extend({}, obj, {});
        var daysArray = getDaysArray();

        data.accounts = accountsObj;
        data.roles = rolesObj[data.account];
        data.days = daysArray;
        data.goals = getDatesObj(data.goals);
        data.working_hours = workingHoursArray;

        $.each(data.submissions, function(key, val) {
            data.yesterday = val;
        });

        if (!data.yesterday) {
            data.yesterday = "-";
        }

        $.each(data.goals, function (key, value) {
            if (inc === 0) {
                data.today = value || "-";
            } else if (inc === 1) {
                data.tomorrow = {};
                data.tomorrow[key] = value;
            } else {
                return false;
            }

            ++inc;
        });


        return data;
    };

    var ajaxGetData = function () {
        var data = {};
        var urlparam = "";

        urlparam += "time=" + currentData.getTime();
        urlparam += "&timeZoneOffset=" + currentData.getTimezoneOffset();

        $.ajax({
           type: "GET",
           url: 'fetchAvailability.htm?' + urlparam,
           dataType: 'json',
           async: false,
           success: function (response) {
                if($.isEmptyObject(response)){
                    console.log(response);
                } else {
                    data = response;
                }
           },
           error: function (error) {
               console.log(error);
           }
       });

       return data;
    };

    var ajaxPostData = function (dialog, next) {
        var data = null;
        var frm = $("#ezdia-week-plan-form");
        var dataArray;
        var goalsArray;
        var data = {
            goals: {}
        };
        var workingHours = '';

        if (next) {
            hideSuccessError(frm);
        }

        if (!frm.valid()) {
            return;
        }

        dataArray = frm.serializeArray();
        goalsArray = $("#ezdia-week-plan-form :input:visible:not(:checkbox)").serializeArray();

        $.each(dataArray, function(i, obj){
            if (obj.name === "account") {
                data.account = obj.value;
            } else if (obj.name === "role") {
                data.role = obj.value;
            }  else if (obj.name === "working_hours") {
                if (workingHours) {
                    workingHours += '##';
                }
                workingHours += obj.value;
            }
        });

        $.each(goalsArray, function(i, obj) {
            if (obj.name !== "account" && obj.name !== "role"  && obj.name !== "working_hours") {
                data.goals[obj.name] = obj.value;
            }
        });

        $.ajax({
            type: "POST",
            url: 'submitAvailability.htm',
            data: {
                "availability": JSON.stringify(data),
                "workingHours": workingHours,
                "time": currentData.getTime(),
                "timeZoneOffset":currentData.getTimezoneOffset()
            },
            dataType: 'json',
            success: function (response) {
                if(!response.success){
                    $('#ezdia-welcome-screen-close').show();
                    hideSuccessError(frm);
                    showSuccessError(frm, {
                        error: true,
                        message: response.message
                    });
                } else {
                    if (next) {
                        $.ezdia.welcomeScreen.getNextDialog(response);
                    } else {
                        $.ezdia.showSuccessError({
                            message: response.message
                        });
                        dialog.dialog("close");
                    }
                }
            },
            error: function (error) {
                console.log(error);
            }
        });
    };

    var showSuccessError = function(frm, obj) {
        var cls = "panel-alert-success";

        if (obj.error) {
            cls = "panel-alert-error";
        }

        frm = frm || $("#ezdia-week-plan-form");

        var wrap = frm.find(".panel-alert");

        wrap.find('span').html(obj.message);
        wrap.addClass(cls).show();

        wrap.find('.remove').off('click').on('click', function() {
            hideSuccessError(frm);
        });

    };

    var hideSuccessError = function(frm) {
        frm.find(".panel-alert").hide().find('span').html("");
    };

    var getWorkingHoursArray = function(str) {
        return str ? str.split('##') : [];
    };

    this.welcomeScreen = {
        onload: function(){
            var _this = this;
            var cookie = doc.cookie;
            var isGoalSet = false;

            $('#ez-top-nav-menu-planWork').on('click', function() {
                isSubmitted = true;
                _this.load();
            });

            if (!cookie) {
                return;
            }

            var cookieKey = 'LastAvailabilityDate=' + getFormattedDate(1) + '-Submitted';

            $.each(cookie.split(';'), function(i, cVal) {
                cVal = cVal && cVal.trim();

                if (cVal === cookieKey && !ssoFlag){
                    isGoalSet = true;
                    return false;
                }
            });

            if (isUserAuthenticated) {
                $('#ez-top-nav-menu-planWork').show();
            }

            if (isUserAuthenticated && !isShareTemplate && !isGoalSet && !ssoFlag) {
                this.load();
            }
        },
        load: function () {
            currentData = new Date();
            var data = ajaxGetData();
            ajaxData = data.result || [];

            if (ajaxData.length) {
                workingHoursArray = getWorkingHoursArray(data.working_hours);
                submittedIndexsCount = ajaxData.length;
                submittedIndexs = [];
                currentDataIndex = 0;
                setAccountAndRoleObj();

                this.dialog(0);
            } else {
                $('#ez-top-nav-menu-planWork').hide();
            }
        },
        dialog: function (index) {
            var template = $.ezdia.template.get('base-welcome-task-plan');
            var data = getData(index);

            content = template(data);
            content = $(content);

            event.call(this);
            dialog();
            validate(data.goals);
            currentDataIndex = index;
        },
        getNextDialog: function (response) {
            var nextIndex;
            isSubmitted = true;

            submittedIndexs[currentDataIndex] = true;
            --submittedIndexsCount;

            if (submittedIndexsCount !== 0) {
                $.each(submittedIndexs, function (i, isSubmited) {
                    if (!isSubmited) {
                        nextIndex = i;
                        return false;
                    }
                });

                if (nextIndex === undefined) {
                    nextIndex = submittedIndexs.length;
                }

                this.dialog(nextIndex);
                showSuccessError(null, {
                    error: !response.success,
                    message: response.message
                });
            }

        }
    };

}).apply($.ezdia, [jQuery, document]);


(function ($) {

    function ajaxPostData() {
        var frm = $("#ez-js-one-login-form");
        var isValid = frm.valid();

        if(!isValid) {
            return;
        }

        var pageParam = $.ezdia.config.pageParams;
        var homeInstance = pageParam.HOME_INSTANCE;
        var data = frm.serializeArray();
        data[data.length] = { name: "username", value: pageParam.email };
        data[data.length] = { name: "tnc", value: "on" };
        data[data.length] = { name: "redirectUrl", value: "/desk/EditProfile.htm" };

        // TODO: REMOVE FIX THIS ONCE NEW CODE IS IMPLEMENTED
        if (!homeInstance && ezdia.config.user) {
          homeInstance = ezdia.config.user.home_instance;
        }

        $.ajax({
            type: "POST",
            url: 'ModifyGlobalPassword.htm',
            data: data,
            dataType: 'json',
            success: function (response) {
                if(response.success){
                    $.ajax({
                        type:'POST',
                        crossDomain: true,
                        url: homeInstance+'/desk/GlobalLogin.htm',
                        xhrFields: { withCredentials: true },
                        data:data,
                        dataType:'text',
                        success:function(){
                            window.location.href = homeInstance+"/desk/EditProfile.htm";
                        },
                        error:function(error){
                            alert('Error','Error while calling login API');
                        }
                    });
                }else{
                    alert("Error",response.msg);
                }
            },
            error: function (error) {
                console.log(error);
            }
        });
    }

    function createDialog() {
        var template = $.ezdia.template.get('one-login-screen');
        var content = template({
            name: globalUserName,
            email: globalUserEmail
        });

        $('body').append(content);
        $('#ez-js-one-login-btn-submit').on('click', function(){
            ajaxPostData($(this));
        });
    }

    function validateForm() {
        $("#ez-js-one-login-form").validate({
            rules: {
                email: {
                  required: true,
                  email: true
                },
                password: {
                  required: true
                },
                confirmpassword: {
                  required: true,
                  equalTo: "#ez-js-password"
                }
            },
            messages: {
                email: "Please enter email",
                password: {
                    required: "Please enter your password"
                },
                confirmpassword: {
                    required: "Please Confirm your Password",
                    equalTo: "Your password and Re-Type Password is not matched"
                }
            },
            errorClass: "text-danger small",
            errorElement: 'div'
        });
    }

    this.oneLogin = {
        init: function() {  // return;
            $('body').addClass('ez-single-login-body');
            createDialog();
            validateForm();
        }
    };
}).apply($.ezdia, [jQuery, document]);

(function ($) {

    this.widgetsInstance = {
        widgets: {},
        add: function(widget, key, _this, action) {

            if (!this.widgets[widget]) {
                this.widgets[widget] = {};
            }

            this.widgets[widget][key] = {
                _this: _this,
                action: action
            };
        },
        clear: function(widget, key) {
            var instance = this.widgets[widget] && this.widgets[widget][key];

            if (instance) {
                instance._this[widget](instance.action);
            }
        },
        clearAll: function(key) {
            var _this = this;
            $.each(this.widgets, function(widget){
                _this.clear(widget, key);
            });
        }
    };

}).apply($.ezdia, [jQuery]);

$.widget("ui.dialog", $.extend({}, $.ui.dialog.prototype, {
    _title: function(title) {
        if (!this.options.title ) {
            title.html("&#160;");
        } else {
            title.html(this.options.title);
        }
    }
}));

//
//window.onbeforeunload = function(e) {
//    console.log(e.type);
//    return "Are you sure to leave this page?";
//}

(function(){

    if (updateGlobalPassword) {
        $.ezdia.oneLogin.init();
    }

    $.ezdia.welcomeScreen.onload();

    if ('onLine' in window.navigator) {
        var snackbar = '';

        $(window).on('offline', function() {
            if (snackbar) {
                $.ezdia.hideSuccessError(snackbar, 0);
            }
            snackbar = $.ezdia.showSuccessError({
                message: '<i class="fa fa-frown-o"></i> You seem to be Offline.',
                autohide: false,
                error: true
            });
        }).on('online', function() {
            if (snackbar) {
                $.ezdia.hideSuccessError(snackbar, 0);
            }
            snackbar =  $.ezdia.showSuccessError({
                message: 'You are online now.'
            });
        });
    }
})();


(function ($) {

    function handelClickEvent() {
         $('#ez-page-content-wrapper').on('click', '[data-org-name]', function () {
            var orgName = $(this).data('orgName');
            $(this).toggleClass('less');
            $('[data-show-more="' + orgName + '"]').collapse('toggle');
        });

        $('#ez-page-content-wrapper').on('click', '[data-org]', function () {
            var $this = $(this).addClass('loading').attr('disabled', 'disabled');
            var org = $this.data('org');

            $('.tooltip').remove();
            getCardData.call(this, org);
        });
    }

    function getCardData(org) {
        var self = this;
        $.ajax({
            type: "GET",
            url: "getGlobalDashboardOrgData.htm?orgName=" + org,
            dataType: 'json',
            success: function (response) {
                if (response.success) {
                    updateCard.call(self, response.msg);
                } else {
                    alert("Error", "Error fetching data.");
                    $(self).removeClass('loading')
                }
            },
            error: function () {
                alert("Error", "Error fetching data.");
            }
        });
    }

    function updateCard(data) {
        data = $.ezdia.getJsonObject(data);
        var template = $.ezdia.template.get('common-workspace-cards');
        var content = template({Organizations: data});

        $(this).closest('[data-col="card"]').replaceWith(content);
    }

    this.globalDashboard = {
        render: function(){
            var pageParams = $.ezdia.config.pageParams;
            var template = $.ezdia.template.get('common-workspace', {SSOOrgCards: 'common-workspace-cards'});
            var data = JSON.parse(pageParams.dashboardData);

            $('#ez-page-content-wrapper').html(template(data));
            setTimeout(function () {
                handelClickEvent();
                pageLoadingDone();
            }, 0);
        }
    };

}).apply($.ezdia, [jQuery]);